const fr = {
    locale: 'fr',
    messages: {
        'price.offered': 'Offert',
        'price.currency': '{price}\u00A0€',
        'routes.cookies.management': '/gestion-cookies',
        'routes.press': '/presse',
        'routes.invest': 'https://finance.burgerking.fr/user',
        'routes.restaurants': '/restaurants',
        'routes.delivery': '/livraison',
        'routes.kingtable': '/kingtable',
        'routes.kingtable.full': '/commande/kingtable',
        'routes.kingtable.catalog': 'catalog',
        'routes.kingtable.catalog.full': '/commande/kingtable/catalog',
        'routes.kingtable.no-desktop': '/commande/kingtable/no-desktop',
        'routes.kingtable.scan': 'scan',
        'routes.kingtable.scan.full': '/commande/kingtable/scan',
        'routes.kingtable.welcome.full': '/commande/kingtable',
        'routes.birthday': '/anniversaire',
        'routes.restaurant': '/restaurant',
        'routes.restaurant.path': '/restaurant/:restaurantPath',
        'routes.timeline': '/histoire',
        'routes.family': '/famille',
        'routes.kingbreakfasts': '/kingbreakfasts',
        'routes.catalog': '/carte',
        'routes.category': '/carte/:categoryId',
        'routes.menus': '/menus/:categoryId',
        'routes.product': '/produit',
        'routes.product.with.id': '/produit/:productId',
        'routes.menu': '/menu',
        'routes.menu.with.id': '/menu/:menuId',
        'routes.faq': '/service-conso',
        'routes.question': 'service-conso',
        'routes.complaint': '/service-conso/reclamation',
        'routes.custom': '/page',
        'routes.customFull': '/page/:name',
        'routes.legalNotice': 'mentions-legales',
        'routes.legalNotice.full': '/page/mentions-legales',
        'routes.cgv.fidelity': 'cgu-fidelite',
        'routes.lottery.rules': 'reglement-roulette-royale',
        'routes.cgv.full': '/page/cgv',
        'routes.cgv': 'cgv',
        'routes.privacy': 'donnees-personnelles',
        'routes.privacy.full': '/page/donnees-personnelles',
        'routes.future.whopper': 'conditions-whopper-of-the-future',
        'routes.veggie.king': 'conditions-veggie-king',
        'routes.cookies': 'cookies',
        'routes.cookies.full': '/page/cookies',
        'routes.allergens': '/page/liste-allergenes',
        'routes.signup': '/inscription',
        'routes.signin': '/connexion',
        'routes.mfa.confirm.code': '/connexion/double-authentification-code',
        'routes.congratulations': '/felicitations',
        'routes.kingdom.dashboard': '/kingdom',
        'routes.kingdom': '/kingdom/:kingdomId',
        'routes.kingdom.card': 'ma-carte-kingdom',
        'routes.kingdom.card.full': '/kingdom/ma-carte-kingdom',
        'routes.kingdom.challenges': 'mes-blasons',
        'routes.kingdom.challenges.full': '/kingdom/mes-blasons',
        'routes.kingdom.give-points': 'donation-couronnes',
        'routes.kingdom.give-points.full': '/kingdom/donation-couronnes',
        'routes.kingdom.privileges': 'mes-privileges',
        'routes.kingdom.privileges.full': '/kingdom/mes-privileges',
        'routes.kingdom.points': 'mes-points',
        'routes.kingdom.points.full': '/kingdom/mes-points',
        'routes.kingdom.orders': 'commandes',
        'routes.kingdom.orders.full': '/kingdom/commandes',
        'routes.kingdom.information': 'moi',
        'routes.kingdom.information.full': '/kingdom/moi',
        'routes.kingdomBurger': 'kingdom-burger',
        'routes.kingdom.fidelity.program': 'programme-de-fidelite-kingdom',
        'routes.kingdom.fidelity.program.full':
            '/page/programme-de-fidelite-kingdom',
        'routes.kingdom.lottery': '/roulette-royale',
        'routes.kingdom.king-scratch': 'king-scratch',
        'routes.reset.password': '/mot-de-passe-oublie',
        'routes.king.birthday': '/kings-birthday',
        'routes.satisfaction': '/enquete-satisfaction',
        'routes.clickandcollect.pathname': '/commande',
        'routes.clickandcollect.signin.signup':
            '/commande/connexion-inscription',
        'routes.clickandcollect.restaurant': '/restaurant',
        'routes.clickandcollect.restaurant.choice': '/commande/restaurant',
        'routes.clickandcollect.delivery': '/choix-retrait',
        'routes.clickandcollect.delivery.choice': '/commande/choix-retrait',
        'routes.clickandcollect.cart.user.infos':
            '/commande/informations-utilisateur',
        'routes.clickandcollect.cart.confirmation': '/commande/confirmation',
        'routes.clickandcollect.cart.confirmationWithParams':
            '/commande/confirmation?token={token}&id={id}',
        'routes.clickandcollect.cart.summary': '/commande/panier',
        'routes.clickandcollect.catalog': '/commande/catalogue',
        'routes.clickandcollect.catalog.short': '/catalogue',
        'routes.clickandcollect.menu': '/commande/menu',
        'routes.clickandcollect.product': '/commande/produit',
        'routes.clickandcollect.product.group': '/commande/produits',
        'routes.clickandcollect.game': '/commande/offre-promotionnelle',
        'routes.clickandcollect.promotions': '/commande/promotions',
        'routes.ecommerce.delivery': 'livraison',
        'routes.ecommerce.kingtable': 'kingtable',
        'routes.dev.screen': '/developer',
        'routes.burgerkare.home': 'burger-kare',
        'routes.burgerkare.people': 'les-equipes',
        'routes.burgerkare.food': 'la-qualite',
        'routes.burgerkare.planet': 'la-planete',
        'routes.tupreferesking': '/tupreferesking',
        'routes.tupreferesking.duel': '/tupreferesking/duel/:tpkToken',
        'routes.tupreferesking.duel.tpkToken':
            '/tupreferesking/duel/{tpkToken}',
        'routes.tupreferesking.duel.win': '/tupreferesking/duel/:tpkToken/win',
        'routes.tupreferesking.duel.win.tpkToken':
            '/tupreferesking/duel/{tpkToken}/win',
        'routes.tupreferesking.legals': '/page/reglement-tupreferesking',
        'routes.tupreferesking.email': '/tupreferesking/email/:tpkToken',
        'routes.tupreferesking.email.tpkToken':
            '/tupreferesking/email/{tpkToken}',
        'routes.tupreferesking.qrCode': '/tupreferesking/qr-code/:tpkToken',
        'routes.tupreferesking.qrCode.tpkToken':
            '/tupreferesking/qr-code/{tpkToken}',
        'routes.meat.origin': 'liste-origine-viandes',
        'routes.meat.origin.full': '/page/liste-origine-viandes',
        'routes.tupreferesking.goodiesGain':
            '/tupreferesking/disponibilite-goodies',
        'routes.order.type.choice': '/mode-commande',
        'routes.deals': '/deals',
        'routes.dev': '/_developer',
        'button.scan.code': 'Scanner un QR code',
        'developer.button.label': 'Menu développeur',
        'developer.api.label': 'API\u00A0:\u00A0',
        'developer.form.success': 'Nouvelles URLs d’APIs enregistrées\u00A0!',
        'error.message': 'Error 404 Page',
        'home.orders.button': 'Mes commandes ({ordersNumber})',
        'home.clickandcollect.button': 'Commander en ligne',
        'home.section.coupons.title': 'Mes dernières offres\u00A0⚡',
        'home.section.cards.title': 'Chaud bouillant\u00A0!',
        'app.home.section.crown.title': 'Menez la vie de king\u00A0👑\u00A0',
        'home.section.cards.subtitle': 'Découvrez les actualités Burger King®',
        'home.restaurants.proximity.baseline':
            'Vous nous cherchez\u00A0?\nVous allez nous trouver\u00A0!',
        'home.restaurants.proximity.one':
            '1\u00A0restaurant à moins de {distance}\u00A0km',
        'home.restaurants.proximity.many':
            '{nbRestaurants}\u00A0restaurants à moins de {distance}\u00A0km',
        'home.restaurants.proximity.button': 'Trouver un restaurant',
        'home.section.kingdom.text':
            "Une soudaine envie qu'on vous fasse la cour\u00A0?",
        'home.section.kingdom.button': 'Rejoindre le Kingdom',
        'home.section.challenges.button': 'Voir tous les avantages',
        'home.section.challenge.title': 'Prochain défi à relever',
        'home.section.challenge.unlocked.title':
            'Prochain avantage à débloquer',
        'home.section.challenge.button': 'Voir tous les défis',
        'home.breadcrumb.start': 'Accueil',
        'timeline.breadcrumb.end': '\u00A0>\u00A0Notre histoire',
        'timeline.baseline': 'On vous raconte notre histoire\u00A0?',
        'timeline.subBaseline': 'Sortez vos cahiers\u00A0!',
        'timeline.button': 'Découvrir',
        'home.products.strate.title':
            'Une petite ou une grosse faim\u00A0?\u00A0🍔',
        'home.products.strate.button': 'DÉCOUVREZ LE KING BREAKFAST',
        'navigation.account.statusMessage.disconnected':
            'Me connecter ou créer mon compte',
        'navigation.account.statusMessage.connected': 'Salut toi\u00A0!',
        'navigation.jobs': 'Nous rejoindre',
        'footer.social.title': 'Qui nous aime, nous suive\u00A0!',
        'footer.applications.title': 'Le King dans votre poche',
        'input.email.placeholder': 'Entrer une adresse e-mail',
        'footer.newsletter.title': 'Pour ne rien rater des offres BURGER KING®',
        'footer.newsletter.submit': 'OK',
        'footer.newsletter.submit.success':
            'Vous êtes bien inscrit à notre newsletter',
        'footer.newsletter.submit.error':
            "Une erreur est survenue lors de l'inscription, merci de réessayer ultérieurement",
        'footer.navigation.confidentialityAgreement':
            'Vous acceptez de recevoir les communications de Burger King® France. Vous pouvez à tout moment utiliser le lien de désabonnement intégré dans nos e-maillings. ',
        'footer.navigation.confidentiality.link':
            'En savoir plus sur la gestion de vos données',
        'footer.navigation.newsletter.errors.emailRequired':
            "Un email valide est requis pour s'inscrire à la newsletter",
        'footer.navigation.press': 'Presse',
        'footer.navigation.invest': 'Investisseurs',
        'footer.legalNotice': 'Mentions légales - CGU',
        'footer.cgv': 'CGV',
        'footer.privacy': 'Politique de protection des données personnelles',
        'footer.cookies': 'Cookies',
        'footer.eatmove.label':
            'Pour votre santé, mangez au moins cinq fruits et légumes par jour. ',
        'footer.eatmove.link.label': 'www.mangerbouger.fr',
        'footer.eatmove.link': 'http://www.mangerbouger.fr',
        'franchise.breadcrumb.end':
            '\u00A0>\u00A0Devenez franchisé Burger King®',
        'franchise.baseline.title': 'Devenez franchisé Burger King®',
        'franchise.baseline.description':
            'Pour développer la marque BURGER KING® en France, nous collaborons également avec des franchisés. Ils vous livrent leur témoignage d’expérience.',
        'franchise.contact.title': 'Nous contacter\u00A0:',
        'franchise.contact.email': 'franchise@burgerking.fr',
        'franchise.contact.recruitment':
            'Karyn Contassot, Chargée de recrutement, formation et intégration des franchisés\nTel\u00A0:\u00A006\u00A008\u00A018\u00A096\u00A047',
        'franchise.contact.director':
            'Xavier Champenois, Directeur de la conversion et du recrutement des franchisés\nTel\u00A0:\u00A006\u00A068\u00A027\u00A037\u00A000',
        'franchise.entrepreneur.title': 'Une âme d’entrepreneur\u00A0?',
        'franchise.entrepreneur.subtitle':
            'Apprenez un savoir-faire qui a fait le succès de milliers de restaurants à travers le monde.',
        'franchise.entrepreneur.button':
            'En savoir plus sur Burger King® France',
        'franchise.profile.title': 'vous avez la passion, nous avons la flamme',
        'franchise.profile.subtitle':
            'Entrepreneur expérimenté et manager de talent, vous êtes le candidat idéal à la franchise\u00A0!',
        'franchise.profile.button': 'Consulter la fiche profil',
        'franchise.application.title':
            'Pret à rejoindre l’aventure burger king®\u00A0?',
        'franchise.application.subtitle':
            'Alors n’attendez plus, devenez franchisé\u00A0!',
        'franchise.application.button': 'télécharger un dossier de candidature',
        'restaurant.order.button': 'Commander',
        'restaurant.no.status': 'Service indisponible',
        'restaurant.no.time': 'horaires indisponibles',
        'restaurant.closed': 'Fermé',
        'restaurant.cac.closed': 'Service fermé',
        'storelocator.restaurant.soon': 'Ouverture prochaine',
        'storelocator.restaurant.opened': "Ouvert jusqu'à {time}",
        'storelocator.restaurant.opened.only-drive':
            'Ouvert uniquement en drive',
        'restaurant.cac.opened': "Service ouvert jusqu'à {time}",
        'restaurant.imminent.opening':
            '{time, plural, =0 {Ouvre dans {time} minute} one {Ouvre dans {time} minute} other {Ouvre dans {time} minutes}}',
        'restaurant.cac.imminent.opening':
            '{time, plural, =0 {Service ouvre dans {time} minute} one {Service ouvre dans {time} minute} other {Service ouvre dans {time} minutes}}',
        'restaurant.imminent.closing':
            '{time, plural, =0 {Ferme dans {time} minute} one {Ferme dans {time} minute} other {Ferme dans {time} minutes}}',
        'restaurant.cac.imminent.closing':
            '{time, plural, =0 {Service ferme dans {time} minute} one {Service ferme dans {time} minute} other {Service ferme dans {time} minutes}}',
        'storelocator.toggle.map': 'Carte',
        'storelocator.toggle.list': 'Liste',
        'storelocator.toggle.filters': 'Filtres',
        'storelocator.filters.by.label': 'Filtrer',
        'storelocator.google.maps': 'Google Maps',
        'storelocator.map.distance': '(\u00A0{distance}\u00A0)',
        'storelocator.distance': '{distance} km',
        'modal.filters.title': 'Filtrer',
        'filters.button.reset': 'Réinitialiser',
        'filters.button.apply': 'Appliquer',
        'storelocator.search.placeholder.desktop':
            'Rechercher une ville ou un code postal\u00A0...',
        'storelocator.search.placeholder.mobile': 'Trouver un restaurant',
        'storelocator.search.button': 'Rechercher',
        'storelocator.title': 'Trouver un restaurant\u00A0?',
        'storelocator.title.landing':
            'Trouver un restaurant\nBurger King\u00A0?',
        'storelocator.title.breadcrumb.end':
            '\u00A0>\u00A0Trouver un restaurant\u00A0?',
        'storelocator.results.title.search':
            '{number, plural, =0 {Aucun restaurant} one {{number} restaurant} other {{number} restaurants}}',
        'storelocator.results.title.nearest':
            '{number, plural, =0 {Oops! aucun restaurant Burger King® à proximité} one {Le restaurant Burger King® le plus proche} other {Les # restaurants Burger King® les plus proches}}',
        'storelocator.results.title.visited':
            '{number, plural, =0 {Aucun restaurant} one {Le dernier restaurant Burger King® consulté} other {Les # derniers restaurants Burger King® consultés}}',
        'storelocator.search.results.see': 'Voir tous les résultats',
        'storelocator.search.results.none.title': 'Aucun restaurant',
        'storelocator.search.results.none.baseline':
            "Nous n'avons pas trouvé de restaurant correspondant à votre recherche",
        'storelocator.search.results.none.cta': 'Retour à la carte',
        'storelocator.restaurant.button.restaurant':
            "Plus d'infos\u00A0? Consulter la fiche du restaurant >",
        'storelocator.restaurant.button.birthday': 'Réserver un anniversaire',
        'storelocator.restaurant.button.itinerary': "J'y vais",
        'storelocator.restaurant.button.delivery': 'Je me fais livrer',
        'storelocator.restaurant.onsite': 'Sur place',
        'storelocator.restaurant.takeaway': 'À emporter',
        'storelocator.restaurant.drive': 'En drive',
        'storelocator.restaurant.click&collect': 'Click & Collect',
        'storelocator.restaurant.delivery': 'En livraison',
        'storelocator.geolocation.required.message':
            'Veuillez activer la géolocalisation de votre téléphone pour accéder aux restaurants à proximité.',
        'notfound.section.cards.title':
            'Mais ici il y a de quoi vous régaler\u00A0!',
        'notfound.section.title': 'oooops\u00A0! Cette page a été dévorée',
        'notfound.button.label': "Retour à l'accueil",
        'error.network.alert.message':
            'Veuillez vérifier votre connexion Internet et réessayer.',
        'error.network.section.title':
            'Oups, pas de connexion internet. Connectez-vous à internet pour utiliser le service.',
        'error.timeout.section.title':
            'Une erreur de connexion vous empêche d’accéder au service.',
        'error.section.title':
            'Une erreur est survenue. Veuillez réessayer ultérieurement.',
        'error.section': 'Oups\u00A0! Une erreur est survenue.',
        'error.button.label': 'Réessayer',
        'error.unhandled.os.version.title': 'Version d’OS non supportée',
        'error.unhandled.os.version.message':
            'Notre application ne supporte pas les versions d’OS inférieures à {minOSVersionForDevice}. Veuillez mettre à jour votre téléphone afin d’accéder à notre application.',
        'catalog.list.label': 'Tous nos produits',
        'catalog.card.title': 'Notre carte',
        'catalog.card.title.breadcrumb.end': '\u00A0>\u00A0Notre carte',
        'catalog.filters.by.label': 'Filtrer par allergènes',
        'catalog.filters.by.label_CC': 'Allergènes',
        'catalog.filters.label': 'Voir uniquement les {elements}\u00A0:',
        'catalog.filters.label.beef': 'Au boeuf',
        'catalog.filters.label.bacon': 'Sans bacon',
        'catalog.filters.label.chicken': 'Au poulet',
        'catalog.filters.label.fish': 'Au poisson',
        'catalog.card.description':
            'Aucune excuse, faites-vous plaisir\u00A0:\u00A0il y en a pour tous les goûts\u00A0!',
        'catalog.card.categoryid': 'CARD',
        'kingdom.navigation.account': 'Mon compte',
        'kingdom.navigation.give-points': 'Don de couronnes',
        'kingdom.navigation.profile': 'Mon profil',
        'kingdom.navigation.orders': 'Mes commandes',
        'kingdom.navigation.fortune.wheel': 'Ma Roulette Royale',
        'kingdom.navigation.king-scratch': "King Gratt'",
        'kingdom.navigation.blazons': 'Mes blasons',
        'kingdom.dashboard.title': 'Mon Kingdom',
        'kingdom.dashboard.title.breadcrumb.end': '\u00A0>\u00A0Mon Kingdom',
        'kingdom.dashboard.description':
            'Votre programme de fidélité vraiment royal\u00A0!',
        'kingdom.dashboard.menuTitle': 'Mon Kingdom',
        'kingdom.dashboard.link.associate.card': 'Associer une carte physique',
        'kingdom.dashboard.marketing.animation.title':
            'En ce moment dans mon Kingdom',
        'kingdom.card.title': 'Ma carte Kingdom',
        'kingdom.challenges.title': 'Mes blasons',
        'kingdom.challenges.partners.title': 'Mes offres partenaires',
        'kingdom.challenges.partners.none':
            'C’est vide pour le moment...\nRestez à l’affût de nos offres partenaires, elles apparaîtront ici\u00A0!',
        'kingdom.privileges.title': 'Mes coupons kingdom',
        'kingdom.loyalty.title': 'Ma carte',
        'kingdom.dashboard.points.title': 'Mes couronnes',
        'kingdom.dashboard.crowns.title':
            '{number, plural, =0 {{number} Couronne} one {{number} Couronne} other {{number} Couronnes}}',
        'kingdom.dashboard.give-points.button': "C'est parti !",
        'kingdom.dashboard.give-points.text1': 'Donnez',
        'kingdom.dashboard.give-points.text2': 'des',
        'kingdom.dashboard.give-points.text3': 'couronnes',
        'kingdom.dashboard.crowns.tab': 'Couronnes\u00A0({number})',
        'kingdom.dashboard.coupons.tab': 'Coupons\u00A0({number})',
        'kingdom.dashboard.privileges.title': 'Mes coupons\u00A0({number})',
        'kingdom.blazons.title': 'Mes blasons débloqués',
        'kingdom.give-points.screen.title': 'Don de couronnes',
        'kingdom.give-points.title': 'Envoyer des couronnes',
        'kingdom.give-points.description':
            'Pure générosité ou besoin de vous faire pardonner, envoyez des couronnes à un ami (qu’il ait un compte Kingdom ou non). Ça fait toujours son petit effet.',
        'kingdom.give-points.warning0':
            "Vous n'avez aucunes couronnes, don impossible",
        'kingdom.give-points.warning1':
            'Attention, c’est votre solde maximum !',
        'kingdom.give-points.warning2': 'Vous devez envoyer au minimun 1 point',
        'kingdom.give-points-warning3':
            'Seules les couronnes issues de commandes affichées ici peuvent faire l’objet d’une donation',
        'kingdom.give-points.form.email.label': 'Address email du receveur',
        'kingdom.give-points.form.email.placeholder':
            "Entrez l'email du receveur",
        'kingdom.give-points.form.loyaltyCardCode.label':
            'Identifiant kingdom du receveur',
        'kingdom.give-points.form.loyaltyCardCode.placeholder':
            "Entrez l'identifiant kingdom",
        'kingdom.give-points.form.validateButton': 'Envoyer des couronnes',
        'kingdom.dashboard.no.unlocked.blazons':
            "Vous n'avez pas encore de blasons débloqués.",
        'kingdom.blazons.unlocked':
            'BRAVOOO\u00A0🔥\u00A0!\u00A0Découvrez vite le nouvel avantage royal que vous venez de débloquer en cliquant ici.',
        'kingdom.blazons.delete':
            'Êtes vous sûr de vouloir supprimer ce blason ?',
        'kingdom.profile.title': 'Mon profil',
        'kingdom.kingdomBurger.title': 'Kingdom burger',
        'kingdom.dashboard.card.text': 'Vous ne pourrez plus vous en passer',
        'kingdom.dashboard.challenges.text':
            'Débloquer des avantages et des récompenses grâce aux blasons\u00A0!',
        'kingdom.dashboard.challenges.unlocked': 'Mes avantages à libérer',
        'kingdom.dashboard.no.unlocked.challenges':
            "Vous n'avez pas encore d'avantages à libérer.",
        'kingdom.dashboard.challenges.locked': 'Mes blasons à débloquer',
        'kingdom.dashboard.no.locked.challenges':
            "Vous n'avez pas encore de blasons à débloquer.",
        'kingdom.dashboard.challenges.cta': 'Découvrir mes blasons',
        'kingdom.dashboard.privileges.text':
            'Des avantages aussi copieux que nos burgers',
        'kingdom.dashboard.profile.text':
            'Complétez ou modifiez vos informations',
        'kingdom.dashboard.kingdomBurger.text':
            'La recette exclusive du Kingdom',
        'kingdom.points.title': 'À vous la vie de king',
        'kingdom.points.title.king': 'Faites place au king\u00A0!',
        'kingdom.points.subtitle': 'Faites vous plaisir avec vos couronnes.',
        'kingdom.points.subtitle.king':
            'Votre menu royal vous attend : à vous le burger personnalisé\u00A0!',
        'kingdom.points.description':
            'Rien n’est trop beau pour nos clients fidèles\u00A0!\nProfitez de vos privilèges\u00A0:',
        'kingdom.points.transform.1': 'Voulez-vous convertir vos',
        'kingdom.points.transform.2': ' en coupon\u00A0?',
        'kingdom.points.transform.yes': 'Oui',
        'kingdom.points.transform.no': 'Non, plus tard',
        'kingdom.points.transform.success': 'Vous avez débloqué votre avantage',
        'kingdom.points.transform.locked': 'Une action en borne est en cours.',
        'kingdom.points.transform.lack':
            'Vous ne possédez pas assez de points.',
        'kingdom.points.transform.not.found': 'La promo est introuvable.',
        'kingdom.points.title.breadcrumb.end':
            '\u00A0>\u00A0À vous la vie de King',
        'kingdom.points.tuto.description.1':
            'Cumulez des couronnes à chaque achat.',
        'kingdom.points.tuto.description.2':
            'Plus vous gagnez des couronnes, plus vous êtes copieusement récompensé.',
        'kingdom.points.tuto.cta': 'À vous de jouer',
        'kingdom.points.level.gold.locked':
            "Le king n'a plus à choisir\u00A0!\nIl a ce qu'il désire\u00A0👑",
        'kingdom.points.level.gold.unlocked': "👑\nC'est vous le king\u00A0!",
        'kingdom.points.next.level.locked':
            'Plus que {number} couronnes pour déverrouiller le prochain palier.',
        'kingdom.points.level.locked': 'Plus que {points} couronnes\u00A0!',
        'kingdom.points.expiration.date':
            'Expiration le {expirationDate} (hors Roulette Royale et Anniversaire)',
        'kingdom.points.expiration.date-v2':
            'Expiration de vos couronnes le {expirationDate} (hors Roulette Royale et Anniversaire).',
        'kingdom.points.expiration.date.with-scratch':
            "Expiration le {expirationDate} (hors King Gratt' et Anniversaire)",
        'kingdom.points.expiration.date-v2.with-scratch':
            "Expiration de vos couronnes le {expirationDate} (hors King Gratt' et Anniversaire).",
        'kingdom.points.offer.promotion': 'PROMO',
        'kingdom.blazon.expiration.date':
            'À utiliser avant le {expirationDate}',
        'kingdom.lottery.tab.title': 'Ma roulette royale',
        'kingdom.lottery.title':
            'Une fois par mois, tournez et remportez une surprise\u00A0! En mai, le Kingdom vous couvre de couronnes\u00A0! L’occasion parfaite pour s’offrir ses produits préférés\u00A0!',
        'kingdom.lottery.connect': 'Connectez vous pour jouer',
        'kingdom.lottery.subtitle':
            'Mais attention\u00A0!! Les couronnes remportées disparaîtront le 1er juin 23:59',
        'kingdom.lottery.next.opening': 'Prochaine ouverture\u00A0:',
        'kingdom.lottery.countdown': 'Revenez dans',
        'kingdom.lottery.days': 'jours et',
        'kingdom.lottery.hours': 'h',
        'kingdom.lottery.minutes': 'min',
        'kingdom.lottery.gain.now.scratch': 'A gratter en ce moment',
        'kingdom.lottery.gain.now.wheel': 'A gagner en ce moment',
        'kingdom.lottery.gain.soon.scratch': 'À gratter prochainement',
        'kingdom.lottery.gain.soon.wheel': 'À gagner prochainement',
        'kingdom.lottery.gain.lost': 'OK j’ai compris',
        'kingdom.lottery.gain.see.crowns': 'Voir mes couronnes',
        'kingdom.lottery.gain.see.coupon': 'Accéder à mon coupon',
        'kingdom.lottery.gain.see.digital': 'Récupérer mon cadeau',
        'kingdom.lottery.oops': 'Oups...',
        'kingdom.lottery.wheel.already.played':
            'Vous avez déjà participé ce mois-ci\u00A0!',
        'kingdom.lottery.wheel.closed': 'La roulette est fermée',
        'kingdom.lottery.wheel.playWithoutKingdomPoint': 'Jouer',
        'kingdom.lottery.wheel.playWithKingdomPoint': 'Rejouer',
        'kingdom.lottery.wheel.playWithKingdomPoint.title':
            'Un tour de plus pour {kingdomPointsForRetry} couronnes\u00A0?',
        'kingdom.lottery.wheel.playWithKingdomPoint.description':
            'Vous avez bien lu\u00A0! Pour {kingdomPointsForRetry} couronnes vous pouvez ce mois-ci refaire tourner la roue pour obtenir un nouveau privilège\u00A0!',
        'kingdom.lottery.wheel.playWithKingdomPoint.unavailable.description':
            'Oups, vous n’avez pas assez de couronnes pour pouvoir tourner la roue à nouveau',
        'kingdom.lottery.wheel.playWithKingdomPoint.key':
            'Utiliser mes {kingdomPointsForRetry} couronnes',
        'kingdom.lottery.wheel.playWithKingdomPoint.unavailable.key':
            'Pas assez de couronnes',
        'kingdom.lottery.error.unavailable':
            'Désolé, la roulette royale n’est plus disponible.',
        'kingdom.lottery.rules': 'Voir le règlement de l’opération',
        'kingdom.give-points.history.title': 'Suivre mes donations',
        'kingdom.give-points.history.sent': 'Envoyées ({number})',
        'kingdom.give-points.history.received': 'Reçues ({number})',
        'kingdom.give-points.history.status.ACCEPTED': 'Accepté',
        'kingdom.give-points.history.status.REFUSED': 'Refusé',
        'kingdom.give-points.history.status.WAITING': 'En attente',
        'kingdom.give-points.history.received.accept.button': 'Accepter le don',
        'kingdom.give-points.history.received.information':
            'Sans acceptation de votre part sous 24 heures, la donation expirera.',
        'kingdom.give-points.history.sent.information':
            'Le receveur devra accepter la donation sous 24 heures pour que la donation soit effective.',
        'kingdom.donation.history.modal.success.title': 'Don accepté',
        'kingdom.donation.history.modal.success.text':
            'Félicitations, vos {points} couronnes vous ont été créditées. Profitez en !',
        'kingdom.donation.history.modal.success.button': "Ok, j'ai compris!",
        'kingdom.donation.history.modal.error.title': 'Oops...',
        'kingdom.donation.history.modal.error.text':
            'Une erreur est survenue, veuillez réessayer dans un instant.',
        'kingdom.donation.history.modal.error.button': 'Réessayer',
        'kingdom.donation.history.modal.maxThreshold.title':
            'Solde maximal atteint',
        'kingdom.donation.history.modal.maxThreshold.text':
            'Vous détenez déjà le solde maximal de 1000 couronnes, vous ne pouvez faire l’objet d’un don.',
        'product.sheet.learn.more': 'En savoir plus',
        'product.sheet.get': "Vous le voulez\u00A0? C'est par ici\u00A0!",
        'product.allergens.title': 'Allergènes',
        'product.allergens.empty':
            "Ce produit ne contient pas d'allergène à déclaration obligatoire.",
        'product.allergens.traces': 'Peut contenir des traces de\u00A0:',
        'product.ingredients.title': 'Ingrédients',
        'product.nutritional.title': 'Valeurs nutritionnelles',
        'product.nutritional.menu.unavailable':
            'Les valeurs nutritionnelles sont indisponibles sur les menus. Pour plus d‘information, rendez-vous sur les pages des produits individuels.',
        'product.nutritional.meat.origin': 'Origine des viandes',
        'product.nutritional.energy': 'Valeurs énergétiques',
        'product.nutritional.fat': 'Matières grasses',
        'product.nutritional.saturates': 'Dont acides gras saturés',
        'product.nutritional.protein': 'Protéines',
        'product.nutritional.carbs': 'Glucides',
        'product.nutritional.sugars': 'Dont sucres rapides',
        'product.nutritional.salt': 'Sel',
        'product.nutritional.portion': 'Par portion',
        'product.nutritional.share': 'Par 100 g',
        'product.nutritional.notice':
            'Apport de reférence journalier pour un adulte type (8400 Kj/2000 Kcal)',
        'product.suggestion.title': 'Vous en demandez encore\u00A0?',
        'product.menu.sides': 'Les accompagnements',
        'product.menu.drinks': 'Les boissons',
        'product.menu.others': 'Le truK en plus',
        'product.menu.desserts': 'Les desserts',
        'product.menu.burgers': 'Les burgers',
        'faq.title': 'Nous contacter',
        'faq.questions.button': 'Voir plus de questions',
        'faq.theme.placeholder': 'Sélectionner un thème',
        'faq.category.placeholder': 'Sélectionner une catégorie',
        'faq.theme.data': 'Information Mes données',
        'faq.theme.main.baseline':
            "Vous n'avez pas trouvé réponse à votre question\u00A0?",
        'faq.theme.second.baseline':
            'Dites-nous tout, on est là pour vous\u00A0!',
        'faq.theme.contact-us': 'Contactez-nous par mail\u00A0:\u00A0',
        'faq.ecommerce.delivery.web':
            'La réclamation livraison n’est pas encore disponible sur le web, rendez-vous sur votre application.',
        'faq.custom.form.title': 'Dites-nous tout\u00A0!',
        'faq.baseline':
            "Une question ou une déclaration\u00A0? C'est ici\u00A0!",
        'faq.form.note.title':
            'Notez votre dernière expérience Burger King (note de 1\u00A0à\u00A010, 1\u00A0étant la note la plus basse).',
        'faq.form.civility.title': 'Vous êtes*',
        'faq.form.lastname.title': 'Nom*',
        'faq.form.address.title': 'Adresse*',
        'faq.form.address.placeholder': 'Tapez ici votre adresse',
        'faq.form.zipCode.title': 'Code Postal*',
        'faq.form.zipCode.placeholder': 'Tapez ici votre code postal',
        'faq.form.city.title': 'Ville*',
        'faq.form.city.placeholder': 'Tapez ici votre ville',
        'faq.form.email.title': 'E-mail*',
        'faq.form.loyalty.title': 'Numéro de carte de fidélité*',
        'faq.form.phone.title': 'Téléphone*',
        'faq.form.message.title': 'Message*',
        'faq.form.message.placeholder': 'Tapez ici votre message',
        'faq.form.restaurant.title': 'Votre restaurant',
        'faq.form.restaurant.department.placeholder': 'Département',
        'faq.form.restaurant.placeholder': 'Restaurant',
        'faq.form.restaurant.date.title': 'Date de votre visite',
        'faq.form.restaurant.date.day.placeholder': 'JJ',
        'faq.form.restaurant.date.month.placeholder': 'MM',
        'faq.form.restaurant.date.year.placeholder': 'AAAA',
        'faq.form.order.title': 'Votre commande',
        'faq.form.order.payment.placeholder': 'Moyen de paiement',
        'faq.form.order.type.placeholder': 'Mode de commande',
        'faq.form.order.delivery.in.app':
            'Livraison depuis votre application Burger King',
        'faq.form.order.external.delivery':
            'Livraison depuis une plateforme (UberEats, Deliveroo…)',
        'faq.form.order.external.delivery.message':
            'Toutes les demandes concernant nos partenaires de livraison (Uber Eats, Deliveroo, Just Eat) sont directement traitées depuis leurs applications. Nous vous invitons à prendre contact avec eux directement\u00A0!',
        'faq.form.order.amount.title': 'Montant de votre commande',
        'faq.form.order.amount.placeholder': 'Tapez ici le montant',
        'faq.form.receipt.chooser.title': 'Ticket de caisse',
        'faq.form.receipt.chooser.takePhotoButtonTitle': 'Prendre une photo',
        'faq.form.receipt.chooser.chooseFromLibraryButtonTitle': 'Phototèque',
        'faq.form.receipt.chooser.cancelButtonTitle': 'Annuler',
        'faq.form.receipt.chooser.permission.title': 'Permission refusée',
        'faq.form.receipt.chooser.permission.text':
            'Pour pouvoir prendre des photos avec votre appareil photo et choisir des images dans votre bibliothèque, autorisez les paramètres nécessaires.',
        'faq.form.receipt.chooser.permission.reTryTitle':
            'Accéder à mes paramètres',
        'faq.form.receipt.chooser.permission.okTitle': 'Je suis sûr',
        'faq.form.receipt.placeholder': 'Ajouter votre ticket de caisse',
        'faq.form.receipt.loaded': 'Votre ticket a bien été ajouté',
        'faq.form.receipt.change': 'Changer votre ticket',
        'form.error.badge.already.earned': 'Vous possédez déjà ce badge',
        'form.error.invalid.student.email':
            'Votre adresse email étudiante ne semble pas valide',
        'form.error.student.already.used': 'Ce mail étudiant est déjà utilisé',
        'form.error.too.old.for.student':
            'Vous ne remplissez pas les conditions requises pour avoir le statut étudiant',
        'faq.form.error.civility': 'Merci de sélectionner une civilité',
        'faq.form.error.invalid': 'Cette valeur est invalide',
        'faq.form.error.file.type':
            "Le fichier sélectionné n'a pas le format jpeg, bmp, tiff, gif, png ou pdf",
        'faq.form.error.file.size.file':
            'La taille du fichier sélectionné dépasse 20 Mo. Veuillez réduire la taille du présent fichier avant de le télécharger à nouveau',
        'faq.form.error.file.size.image':
            'La taille du fichier sélectionné dépasse 1 Mo. Veuillez réduire la taille du présent fichier avant de le télécharger à nouveau',
        'faq.form.success.message':
            'Merci\u00A0! Votre message a été envoyé au service clients BURGER KING® France. Nous avons bien pris en compte votre demande qui sera traitée dans les meilleurs délais.',
        'faq.form.success.button': "Retourner à la page d'accueil",
        'faq.form.agreements':
            "En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de ma demande de réclamations et de la relation commerciale qui peut en découler.",
        'faq.form.legalNotice.start':
            'Vous pouvez exercer votre droit d’accès, de rectification, de portabilité et de suppression de vos données personnelles, ou vous opposer à leur traitement, en nous adressant un courrier électronique à\u00A0',
        'faq.form.legalNotice.end':
            '. Pour en savoir plus sur la gestion de vos données et vos droits, cliquer\u00A0',
        'faq.form.legalNotice.mail': 'dpo@burgerking.fr',
        'faq.form.legalNotice.link': 'ICI',
        'complaint.oups': 'Oops ! Cette page semble invalide',
        'complaint.errorBanner':
            'Une erreur est survenue. Nous ne parvenons pas à envoyer votre message.',
        'complaint.button': `Revenir à l'accueil`,
        'complaint.getError': `Cette réclamation n'existe pas ou une erreur technique est survenue.`,
        'complaint.reclamationNumber': 'Votre réclamation #{complaintNumber}',
        'complaint.desc':
            'Communiquez avec le restaurant pour faire suite à votre demande',
        'complaint.date': 'Envoyé le {date} à {hour}',
        'complaint.input.placeholder':
            'Entrez votre message ici pour communiquer avec le restaurant',
        'complaint.answer.button': 'Répondre',
        'complaint.modal.title': 'Message envoyé',
        'complaint.modal.button': `Ok, j'ai compris`,
        'complaint.modal.desc':
            'Votre message à bien été envoyé au restaurant. Vous recevrez une réponse via email prochainement.  ',
        'complaint.warningData': `Attention : Lors de votre échange avec le restaurant, ne communiquez aucune donnée à caractère sensible (ID Kingdom, numéro de téléphone, adresse postale, adresse e-mail, numéro de carte d'identité, numéro de sécurité sociale, données de localisation, adresse IP ou données détenues par un hôpital ou un médecin).`,
        'family.title': '\u00A0>\u00A0Le coin famille',
        'family.game.title': 'Aires de jeux',
        'family.game.description':
            "Pour une visite en famille réussie, quoi de mieux que nos aires de jeux réservées aux enfants où ils pourront s'amuser et se dépenser sans limite\u00A0!",
        'family.birthday.title': 'Le plus royal des anniversaires',
        'family.birthday.button': 'Réservez-le dès maintenant',
        'family.activity.title': 'En ce moment',
        'family.activity.description':
            "Une activité enfant offerte pour tout achat d'un menu enfant + un menu adulte",
        'family.activity.button': 'Réservez',
        'family.main.title': 'pas 1, mais 2 menus enfants',
        'family.main.description':
            'On n’a pas les mêmes besoins et les mêmes envies à 5 et 10 ans… À chacun son menu\u00A0! Chez Burger King®, on sait faire la différence ;)',
        'family.parents.title':
            'ET POUR GAGNER LA MEDAILLE DU MEILLEUR PARENT…',
        'family.parents.description':
            'Burger King® propose des aires de jeu pour vos enfants et s’occupe de leur organiser des anniversaires dignes d’un King\u00A0! Ne nous dites pas merci ;)',
        'family.surprises.title': 'DES SURPRISES QUI EVOLUENT AVEC EUX',
        'family.surprises.description':
            'Parce qu’on ne s’amuse pas de la même façon en grandissant, nos jouets sont adaptés aux plaisirs de vos enfants\u00A0!',
        'family.menu.title': 'DES MENUS ADAPTéS AUX BESOINS DE VOS ENFANTS',
        'family.menu.description':
            'Nos deux menus ont été soigneusement élaborés en fonction des besoins de chacun\u00A0! Mais pas de jaloux, tout est délicieux ;)',
        'cookies.consent.message':
            'En cliquant sur « Tout accepter », vous acceptez l’utilisation de cookies à usages techniques nécessaires à son bon fonctionnement, ainsi que des cookies, y compris des cookies tiers, à des fins statistiques, de publicité ou de personnalisation pour vous proposer des services et des offres adaptés à vos centres d’intérêts sur notre site et ceux de tiers.',
        'cookies.consent.accept.all': 'Tout accepter',
        'cookies.consent.decline.all': 'Tout refuser',
        'cookies.consent.accept': 'Valider et accepter',
        'cookies.management.title': 'Gestion des cookies',
        'cookies.management.button': 'Personnaliser',
        'cookies.management.help':
            'Les cookies sont des petits fichiers textes susceptibles d’être enregistrés dans un espace dédié du disque dur de votre terminal (ordinateur,smartphone, tablette, …), qui peuvent être utilisés par les sites internet pour une meilleure expérience utilisateur. Notre site utilise différents types de cookies: à des fins techniques pour le bon fonctionnement de notre site, à des fins de personnalisation du contenu de notre site en fonction de vos préférences, à des fins statistiques pour analyser notre trafic, et à des fins publicitaires pour vous proposer des services et des offres adaptés à vos centres d’intérêts. Certains sont placés par les services tiers qui apparaissent sur nos pages. La loi stipule que nous ne pouvons stocker des cookies sur votre appareil que s’ils sont strictement nécessaires au fonctionnement de notre site. Pour tous les autres types de cookies, nous avons besoin de votre permission. À tout moment, vous pouvez modifier ou retirer votre consentement dès la déclaration relative aux cookies sur notre site ou ultérieurement dans vos paramètres. Pour en savoir plus sur les cookies, veuillez consulter notre page dédiée aux cookies. Pour en savoir plus sur qui nous sommes, comment vous pouvez nous contacter et comment nous traitons vos données personnelles, veuillez consulter notre politique de protection des données personnelles.',
        'cookies.management.enabled': 'ACTIVÉS',
        'cookies.management.enabled.obligatoire': 'ACTIVÉS (OBLIGATOIRE)',
        'cookies.management.disabled': 'DÉSACTIVÉS',
        'cookies.management.types': 'Types de cookies',
        'cookies.management.mandatory.title': 'Fonctionnement',
        'cookies.management.mandatory.description':
            'Ces cookies ne concernent que le fonctionnement de notre site. Ils sont essentiels et nécessaires pour assurer le fonctionnement optimal de notre site, et pour vous permettre d’utiliser ses services et fonctionnalités. Sans ces cookies qui sont absolument nécessaires, notre site ne fonctionnera pas aussi bien que nous le souhaitons. Nous serions alors dans l’incapacité de fournir le site ou certains services ou fonctionnalités demandés.',
        'cookies.management.tracking.title': 'Statistiques',
        'cookies.management.tracking.description':
            'Ces cookies nous permettent de suivre l’activité du site, d’établir des statistiques de fréquentation et d’utilisation des divers éléments composant notre site (rubriques et contenus visité, parcours, …), afin d’en améliorer l’intérêt, l’ergonomie et la performance en fonction de l’utilisation réelle. Ces données sont recueillies de manière anonyme.',
        'cookies.management.media.title': 'Publicité',
        'cookies.management.media.description':
            'Ces cookies, y compris de tiers, sont utilisés à des fins marketing et publicitaires. Ils nous permettent d’afficher sur les sites internet que vous consultez du contenu publicitaire correspondant à vos centres d’intérêts.',
        'hero.actionurl': '/produit/whopper',
        'hero.actionlabel': 'Découvrez-le',
        'democratic.widget.label': 'Je vote',
        'democratic.election.title':
            'Votez pour élire les prochains démocratique burgers',
        'democratic.election.subtitle':
            'Chaque semaine, votez pour les deux burgers qui seront chacun à 2€',
        'democratic.election.button': 'Valider mon vote',
        'democratic.vote.title': 'A voté',
        'democratic.vote.description': 'Revenez demain pour voter à nouveau.',
        'democratic.vote.button': 'Voir les tendances',
        'democratic.vote.form.candidate.not.found.error':
            'Désolé, mais votre sélection ne correspond pas à un candidat.',
        'democratic.vote.form.candidate.already.elected.error':
            'Désolé, mais vous ne pouvez pas voter pour ce candidat car il a déjà été élu.',
        'democratic.vote.form.not.allowed.error':
            "Désolé, mais vous n'êtes pas autorisé à voter.",
        'democratic.vote.form.already.voted.error':
            "Désolé, mais vous n'êtes pas autorisé à voter plus d'une fois par jour",
        'democratic.vote.form.closed.error':
            'Désolé, mais les éléctions sont terminées.',
        'democratic.vote.form.no.captcha.error':
            "Pour voter, merci de mettre à jour l'application Burger King® France",
        'democratic.tendances.title': 'Les tendances',
        'democratic.tendances.last.update':
            'Dernière actualisation\u00A0:\u00A0{lastUpdate}',
        'democratic.tendances.button': "Retour à l'accueil",
        'democratic.countdown.title':
            'La France a élu les prochains Démocratique Burger',
        'democratic.countdown.description':
            'Disponible en restaurant dans\u00A0:',
        'democratic.countdown.button': 'Élire le suivant',
        'kingtable.title': 'King Table',
        'delivery.title': 'King Delivery',
        'delivery.subtitle': 'Vérifiez la disponibilité près de chez vous.',
        'delivery.title.breadcrumb.end': '\u00A0>\u00A0Livraison',
        'delivery.success': 'La livraison est disponible dans cette ville.',
        'delivery.fail': "La livraison n'est pas disponible dans cette ville.",
        'delivery.form.email.title': "M'informer quand ce sera le cas",
        'delivery.form.email.placeholder': 'Tapez ici votre e-mail',
        'delivery.form.email.submit': 'OK',
        'delivery.deliveroo.url': 'https://deliveroo.fr/fr/marques/burger-king',
        'delivery.ubereats.url': 'https://www.ubereats.com/fr-FR/burger-king/',
        'delivery.form.email.success':
            'Merci, nous vous tiendrons informé, restez connecté.',
        'delivery.deliveroo.app.ios.url':
            'https://itunes.apple.com/fr/app/deliveroo/id1001501844?mt=8',
        'delivery.deliveroo.app.android.url':
            'https://play.google.com/store/apps/details?id=com.deliveroo.orderapp&hl=fr',
        'delivery.ubereats.app.ios.url':
            'https://apps.apple.com/fr/app/uber-eats-livraison-de-repas/id1058959277',
        'delivery.ubereats.app.android.url':
            'https://play.google.com/store/apps/details?id=com.ubercab.eats',
        'delivery.order.cancelled': 'Commande annulée',
        'delivery.order.cancelled.description':
            'Un incident nous a contraint à annuler votre commande en cours.',
        'delivery.order.not.delivered': 'Commande non livrée',
        'delivery.order.not.delivered.unreachable.customer':
            'Votre commande n’a pas pu être livrée car le livreur n’a pas réussi à vous joindre.',
        'delivery.driver.unavailable':
            'Aucun livreur n’est disponible pour ce restaurant. Veuillez réessayer ultérieurement ou sélectionner un autre restaurant.',
        'app.store.ios':
            'https://itunes.apple.com/fr/app/burger-king-france/id924879230?mt=8',
        'app.store.android':
            'https://play.google.com/store/apps/details?id=air.com.unit9.bkFrApp',
        'app.menu.history': 'Notre histoire',
        'app.menu.family': 'Le coin famille',
        'app.menu.franchise': 'Devenir franchisé',
        'app.menu.faq': 'Une question\u00A0?',
        'app.menu.privacy': 'Politique de protection des données personnelles',
        'app.menu.cookies': 'Gestion des Cookies',
        'app.error.button.retry': 'Réessayer',
        'app.error.button.ok': 'OK',
        'app.error.button.cancel': 'Annuler',
        'app.error.network.title': 'Erreur de connexion',
        'app.error.network.message':
            'Allo\u00A0? Vous êtes sous un tunnel\u00A0? Reconnectez le réseau',
        'app.error.api.title': 'Erreur inattendue',
        'app.error.api.message':
            "Désolé, je ne suis pas disponible aujourd'hui, j'ai tennis. Retrouvez-nous dans quelques instants\u00A0...",
        'app.link.do.not.login': "S'inscrire plus tard",
        'app.signup.tab.label': "S'inscrire",
        'orb.card.order': 'VOTRE COMMANDE',
        'orb.card.order.light': 'Commande',
        'orb.scan.title': 'SUIVI DE COMMANDE',
        'orb.scan.subtitle':
            "Scanner le QR code de votre ticket de caisse afin de suivre l'état de votre commande",
        'modal.notification.title':
            'Autorisez-vous BURGER KING® France à vous envoyer des notifications\u00A0?',
        'modal.notification.orb.message':
            "Les notifications sont nécessaires pour suivre l'avancement de votre commande sur votre téléphone. Elles peuvent inclure alertes, sons et pastilles d'icônes.",
        'modal.location.title':
            "Autorisez-vous BURGER KING® France à accéder à vos données de localisation lorsque vous utilisez l'app\u00A0?",
        'modal.notification.authentification.message':
            "Les notifications vous permettront de profiter pleinement de votre programme Kingdom. Elles peuvent inclure alertes, sons et pastilles d'icônes.",
        'modal.notification.button.cancel': 'Non merci',
        'modal.notification.button.settings': 'Aller à mes Réglages',
        'modal.tutorial.title': 'Tuto Royal',
        notifications: 'Notifications',
        'modal.notifications.permission':
            'Activez nos notifications pour être informé des bons plans, actualités et nouveaux produits.',
        'modal.notifications.permission.error':
            'Une erreur est survenue. Veuillez vérifier les paramètres de votre navigateur.',
        'orb.status.error.message':
            'Oups, nous rencontrons des difficultés à afficher le statut de votre commande',
        'orb.modal.yes': 'OUI',
        'orb.modal.no': 'NON',
        'orb.modal.title': 'SUPPRESSION',
        'orb.modal.unfollow':
            'Êtes-vous sûr de ne plus suivre cette commande\u00A0?',
        'orb.modal.scan.error': "Ce code n'est pas valide, veuillez réessayer",
        'orb.modal.scan.error.title': 'OUPS',
        'orb.modal.scan.notAvailable':
            "Ce service n'est pas encore disponible dans ce restaurant.\n\nEncore un peu de patience\u00A0!",
        'orb.card.order.status.done':
            'Votre commande a bien été récupérée.\nMerci de votre visite\u00A0!',
        'orb.delivery.card.order.status.done':
            'Votre commande a bien été livrée.\nMerci de votre visite\u00A0!',
        'orb.card.order.status.ready': 'En attente de récupération',
        'orb.card.order.status.waiting': 'En attente de paiement',
        'orb.card.order.status.cancelled':
            'Votre commande a été annulée, vous ne serez pas débité',
        'orb.card.delivery.order.status.cancelled':
            'Votre commande a été annulée',
        'orb.card.order.status.inprogress.full': 'En cours de préparation',
        'orb.card.order.status.inprogress.big':
            'Votre commande est actuellement en cours de préparation',
        'orb.orderslist.title': 'ATTENTION CHAUD\u00A0!',
        'orb.orderslist.scan': 'SCANNER UNE NOUVELLE COMMANDE',
        'orb.pick.up.price': '{pickup} · {price}',
        'settings.open': 'Ouvrir les réglages',
        'settings.activate.camera': "Activer l'accès à l'appareil photo",
        'scan.activate': 'Activer ma caméra',
        'signup.title': "S'inscrire",
        'signup.baseline': 'Votre loyauté sera copieusement récompensée',
        'signup.breadcrumb.end': '\u00A0>\u00A0Inscription',
        'signup.form.title': 'Créez votre compte',
        'signup.login.label': 'Vous êtes déjà inscrit\u00A0?',
        'signup.login.button': 'Me connecter',
        'signup.success.title': "Le kingdom n'attend plus que vous\u00A0",
        'signup.success.message.mail':
            'Vous allez recevoir un e-mail d’activation que nous venons de vous envoyer à l’adresse {mail} pour confirmer la création de votre compte Kingdom.',
        'signup.success.message.resend.start':
            'Vous n’avez rien reçu\u00A0? Vous pouvez vérifier vos spams ou cliquer\u00A0',
        'signup.success.message.resend.link': 'ici',
        'signup.success.message.resend.end':
            '\u00A0pour le recevoir à nouveau.',
        'signup.success.button.label': "J'ai compris",
        'signup.success.message.kingdom':
            'Profitez dès à présent de vos privilèges liés à votre compte kingdom\u00A0!',
        'signup.form.email.title': 'E-mail*',
        'signup.form.password.title': 'Mot de passe*',
        'signup.form.password.placeholder': '8 caractères minimum',
        'signup.form.birthdate.error':
            'Vous ne pouvez pas créer de compte si vous avez moins de {minAge} ans.',
        'signup.form.parental.error':
            'Veuillez certifier que vous avez obtenu un accord parental pour créer votre compte Kingdom',
        'signup.form.agreements.error':
            "Veuillez accepter les Conditions Générales d'Utilisation pour pouvoir créer votre compte Kingdom",
        'signup.form.parental':
            'Je certifie avoir obtenu l’accord de mes parents',
        'signup.form.optin':
            "J'accepte de recevoir par email des offres personnalisées de la part de Burger\u00A0King®\u00A0France",
        'signup.form.optin.reunion':
            "J'accepte de recevoir par email des offres personnalisées de la part de Burger\u00A0King®\u00A0Réunion",
        'signup.form.agreements': 'Je reconnais avoir pris connaissance des ',
        'signup.form.agreements.link':
            'conditions générales d’utilisation du programme de fidélité KINGDOM ',
        'signup.form.agreements.end': 'et les accepter sans réserve.',
        'signup.form.student-declaration':
            'Je déclare être étudiant et avoir moins de 30 ans.',
        'signup.form.button.send': 'Créer mon compte',
        'signup.form.send.error.loyalty':
            'Désolé, cette carte a déjà été associée à un compte client.',
        'signup.form.send.error.email':
            "Désolé, l'adresse e-mail renseignée est invalide.",
        'signup.form.send.error.young':
            'Désolé, vous ne pouvez pas créer de compte si vous avez moins de 13 ans.',
        'signup.form.send.error.social':
            'Désolé, mais un utilisateur est déjà inscrit avec ce compte.',
        'signup.form.send.error.password':
            'Désolé, mais votre mot de passe ne respecte pas le format imposé. Votre mot de passe doit comporter 8 caractères au minimum, au moins 1 lettre majuscule, 1 caractère spécial (!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~) et un caractère numérique',
        'congratulations.success.title': 'Félicitations\u00A0!',
        'congratulations.success.baseline':
            'Vous faites désormais partie des privilégiés\u00A0!',
        'congratulations.success.message':
            'Découvrez dès à présent les avantages qui vous sont réservés en vous connectant.',
        'congratulations.success.button.label': 'Se connecter',
        'congratulations.success-authed.button.label': 'Accéder à mon Kingdom',
        'congratulations.error.message':
            "Désolé, votre appétit pour faire votre entrée au sein du Kingdom Burger King® France n'a pas été suffisant. Pour pouvoir y remédier, merci de cliquer sur le lien ci-dessous afin de bénéficier d'une nouvelle chance.",
        'congratulations.error.button.label': 'Recevoir un nouveau mail',
        'app.signin.tab.label': 'Se connecter',
        'signin.title': 'Se connecter',
        'signin.baseline': 'Votre loyauté sera copieusement récompensée',
        'signin.breadcrumb.end': '\u00A0>\u00A0Connexion',
        'signin.login.label': 'Vous êtes déjà inscrit\u00A0?',
        'signin.form.email.title': 'E-mail*',
        'signin.form.password.title': 'Mot de passe*',
        'signin.form.password.placeholder': 'Tapez ici votre mot de passe',
        'signin.form.error.account.inactive':
            "Nous ne pouvons pas vous identifier car vous n'avez pas encore validé votre compte depuis le lien d'activation que nous vous avons envoyé.",
        'signin.form.error.account.inactive.resend':
            "Je souhaite recevoir de nouveau le mail d'activation.",
        'signin.form.error.invalid.credentials':
            'Votre identifiant ou votre mot de passe est incorrect.',
        'signin.form.error.login.type.invalid':
            'Cet email est déjà utilisé pour un autre mode de connexion.',
        'signin.form.keep.logged.in': 'Rester connecté',
        'signin.not.registered.create': 'Inscrivez-vous',
        'signin.not.registered.title': 'C’est royal\u00A0!',
        'signin.not.registered.description':
            'Cumulez des couronnes à chaque achat',
        'signin.not.registered.description2':
            'Transformez-les en délicieux produits offerts',
        'signin.reset.password': 'Oups, un trou de mémoire\u00A0?',
        'signin.biometrics.prompt.message': 'Connectez-vous à votre Kingdom',
        'signin.mfa.wrong.credentials':
            'Le code de sécurité ne correspond pas. Veuillez vérifier.',
        'signin.mfa.expired.credentials':
            'Le code de sécurité semble expiré. Veuillez vous reconnecter.',
        'signin.mfa.new.code.sent':
            'Un nouveau code vient de vous être envoyé.',
        'signin.mfa.enter.code': 'Entrez votre code de sécurité',
        'signin.mfa.enter.code.details':
            'Afin de vérifier votre identité et protéger vos données personnelles, nous vous avons envoyé un code de sécurité sur votre adresse',
        'signin.mfa.enter.code.no.code':
            'Vous n’avez pas reçu de code ? Vérifier vos spams ! Le code peut avoir un délai de quelques minutes.',
        'signin.mfa.enter.verify.code.button': 'Vérifier mon code',
        'signin.mfa.enter.reconnect.button': 'Me reconnecter',
        'signin.mfa.enter.send.new.code':
            'J’ai vérifié, renvoyer un code par email',
        'signin.mfa.enter.code.wrong.code':
            'Le code de sécurité est expiré. Veuillez recommencer la procédure.',
        'signin.mfa.enter.code.expired.code':
            'Le code de sécurité ne correspond pas. Veuillez vérifier.',
        'reset.password.breadcrumb.end': '\u00A0>\u00A0Mot de passe oublié',
        'reset.password.mail.title': 'Mot de passe oublié\u00A0?',
        'reset.password.mail.form.message':
            'Saisissez votre adresse e-mail pour recevoir les instructions expliquant comment réinitialiser votre mot de passe.',
        'reset.password.mail.form.button.label': 'Envoyer',
        'reset.password.mail.return.message.start':
            "Ou revenez à l'écran de\u00A0",
        'reset.password.mail.return.message.link': 'connexion',
        'reset.password.mail.success.title': 'Mot de passe réinitialisé',
        'reset.password.mail.success':
            'Si votre adresse e-mail correspond à un compte Kingdom, vous devriez recevoir un lien dans votre boîte de réception d’ici quelques instants. Veuillez ouvrir ce lien pour réinitialiser votre mot de passe. Si vous n’avez toujours rien reçu, vous pouvez faire un renvoi d’e-mail en cliquant\u00A0',
        'reset.password.mail.success.resend.link': 'ici.',
        'reset.password.mail.success.button.label':
            "Retour à l'écran de connexion",
        'reset.password.mail.submit.error':
            "Oups, il n'y a aucun compte utilisateur associé à cette adresse e-mail, veuillez vérifier les informations ci-dessus",
        'reset.password.form.email.title': 'E-mail*',
        'reset.password.update.title': 'Mettre à jour le mot de passe',
        'reset.password.update.form.message':
            'Veuillez saisir votre nouveau mot de passe',
        'reset.password.update.submit.token.error':
            'Désolé, mais votre demande a expiré',
        'reset.password.update.submit.password.error':
            'Desolé, mais les deux champs de saisie du mot de passe ne correspondent pas',
        'reset.password.form.update.new.title': 'Nouveau mot de passe*',
        'reset.password.form.update.new.placeholder': 'Mot de passe',
        'reset.password.form.update.confirm.title':
            'Confirmation du mot de passe*',
        'reset.password.form.update.confirm.placeholder':
            'Confirmez votre mot de passe',
        'reset.password.update.form.button.label': 'Confirmer',
        'reset.password.update.success':
            'Votre nouveau mot de passe a bien été pris en compte. Vous pouvez désormais vous reconnecter en cliquant sur le lien ci-dessous.',
        'reset.password.update.success.button.label': 'Me connecter',
        'kingdom.profile.title.breadcrumb.end': '\u00A0>\u00A0Moi',
        'kingdom.profile.description':
            "Pour que personne d'autre que vous ne profite de vos privilèges",
        'kingdom.profile.form.firstname.title': 'Prénom',
        'kingdom.profile.form.identifiers.title': 'Mes identifiants',
        'kingdom.profile.form.identifiers.email.title': 'E-mail*',
        'kingdom.profile.form.identifiers.email.link': 'Modifier mon e-mail',
        'kingdom.profile.form.email.activation.success':
            'Votre e-mail a bien été modifié.',
        'kingdom.profile.form.email.activation.error':
            'Une erreur est survenue durant l’activation de votre nouvel e-mail.',
        'kingdom.profile.form.email.update.success':
            'Votre demande de modification d’e-mail a bien été prise en compte. Vous allez recevoir un e-mail pour valider votre nouvelle adresse.',
        'kingdom.profile.form.email.title': 'Modifier mon e-mail',
        'kingdom.profile.form.email.new.title': 'Nouvel e-mail*',
        'kingdom.profile.form.email.new.placeholder':
            'Tapez ici votre nouvel e-mail',
        'kingdom.profile.form.email.new.confirmation.title':
            'Confirmez votre nouvel e-mail*',
        'kingdom.profile.form.email.new.confirmation.placeholder':
            'Confirmez ici votre nouvel e-mail',
        'kingdom.profile.form.email.mentions':
            'Un mail d’activation va vous être envoyé sur votre nouvel e-mail renseigné. Vous devez impérativement cliquer sur le lien de cet e-mail et vous reconnecter pour que le changement d’e-mail soit effectif.',
        'kingdom.profile.form.email.error':
            'Vous ne pouvez pas modifier votre adresse e-mail.',
        'kingdom.profile.form.identifiers.password.link':
            'Modifier mon mot de passe',
        'kingdom.profile.form.identifiers.touchID':
            'Authentification par TouchID',
        'kingdom.profile.form.identifiers.faceID': 'FaceID',
        'kingdom.profile.form.password.title': 'Modifier mon mot de passe',
        'kingdom.profile.form.password.old.title': 'Ancien mot de passe*',
        'kingdom.profile.form.password.old.placeholder':
            'Tapez ici votre ancien mot de passe',
        'kingdom.profile.form.password.old.error':
            "L'ancien mot de passe que vous avez renseigné est incorrect.",
        'kingdom.profile.form.password.new.title': 'Nouveau mot de passe*',
        'kingdom.profile.form.password.new.placeholder':
            'Tapez ici votre nouveau mot de passe',
        'kingdom.profile.form.password.confirmed.title':
            'Confirmez votre nouveau mot de passe*',
        'kingdom.profile.form.password.confirmed.placeholder':
            'Confirmez ici votre nouveau mot de passe',
        'kingdom.profile.form.password.success':
            'Votre mot de passe a bien été modifié.',
        'kingdom.profile.form.password.success.button': 'OK',
        'kingdom.profile.form.information.title':
            'Mes informations personnelles',
        'kingdom.profile.form.student.deactivate.profile.error':
            'Une erreur est survenue lors de la désactivation de votre profil étudiant',
        'kingdom.profile.form.student.activate.profile': 'Mon offre étudiante',
        'kingdom.profile.form.student.activate.profile.description':
            'Profitez de promotions et d’offres exclusives, exclusivement réservé aux étudiants !',
        'kingdom.profile.form.student.activate.profile.activated':
            'Votre offre étudiante Le Bon Bail est déjà activée. Retrouvez votre coupon dans vos coupons Kingdom !',
        'kingdom.profile.form.student.activate.profile.local.activated':
            'Votre Blason Étudiant est devenu Le Bon Bail, toujours la même offre mais un tout nouveau nom. Retrouvez votre coupon dans vos coupons Kingdom ! ',
        'kingdom.profile.form.student.school.type':
            'Saisissez votre niveau d‘étude',
        'kingdom.profile.form.student.school.type.placeholder':
            'Niveau d‘étude',
        'kingdom.profile.form.student.school.type.middle.school': 'Collège',
        'kingdom.profile.form.student.school.type.high.school': 'Lycée',
        'kingdom.profile.form.student.school.type.higher.education':
            'Etudes supérieures',
        'kingdom.profile.form.student.email': 'Adresse email étudiant',
        'kingdom.profile.form.student.wrong.email':
            'L’adresse email saisie ne semble pas être une adresse étudiante',
        'kingdom.profile.form.student.no.email':
            'Pas d’email étudiant ? Contactez le service client',
        'kingdom.profile.form.student.email.infos':
            'Cet email ne sera pas utilisé à des fins commerciales, mais uniquement pour vérifier votre statut étudiant',
        'kingdom.profile.form.student.deactivate.profile':
            'Désactiver mon profil étudiant',
        'kingdom.profile.form.student.deactivate.profile.infos':
            'Êtes vous sûr de vouloir désactiver votre profil étudiant ? Vous perdrez vos avantages étudiant.',
        'kingdom.profile.form.student.incomplete': 'Profil étudiant incomplet',
        'kingdom.profile.form.student.incomplete.infos':
            'Êtes vous sûr de vouloir quitter cette page ?\n Vos modifications ne seront pas sauvegardées.',
        'kingdom.profile.form.student.school.type.MIDDLE_SCHOOL': 'Collège',
        'kingdom.profile.form.student.school.type.HIGH_SCHOOL': 'Lycée',
        'kingdom.profile.form.student.school.type.HIGHER_EDUCATION':
            'Etudes supérieures',
        'kingdom.profile.form.student.success': 'Profil étudiant activé !',
        'kingdom.profile.form.student.success.infos':
            'Bravo, vous avez déverrouillé votre coupon étudiant ! Utilisez-le lors de votre commande pour profiter de votre offre étudiante.',
        'kingdom.profile.form.student.success.cta': 'Accéder à mes coupons',
        'kingdom.profile.form.information.lastname.title': 'Nom',
        'kingdom.profile.form.information.phone.title': 'Téléphone',
        'kingdom.profile.form.information.birthdate.title': 'Date de naissance',
        'kingdom.profile.form.car': 'Ma voiture',
        'kingdom.profile.form.family.title': 'Ma famille royale',
        'kingdom.profile.form.family.text':
            'Envie de gâter vos enfants\u00A0? Indiquez-nous leur date de naissance pour recevoir des offres personnalisées et des surprises pour leur anniversaire\u00A0! On en connaît qui vont être contents\u00A0…',
        'kingdom.profile.form.family.child.label': 'Enfant {number}',
        'kingdom.profile.form.family.button.add': 'Ajouter un enfant',
        'kingdom.profile.form.family.add.max.reached':
            "Le nombre maximum d'enfants a été atteint",
        'kingdom.profile.form.family.delete.message':
            'Cette opération est définitive, souhaitez-vous vraiment supprimer cette information\u00A0?',
        'kingdom.profile.form.restaurant.title': 'Mon restaurant favori',
        'form.restaurant.not.kingdom':
            'Votre restaurant ne participe pas au programme Kingdom',
        'form.restaurant.not.birthday':
            "Votre restaurant ne permet pas de réserver l'anniversaire de votre enfant",
        'kingdom.profile.form.restaurant.button.add': 'Ajouter un restaurant',
        'kingdom.profile.form.restaurant.delete.message':
            'Cette opération est définitive, souhaitez-vous vraiment supprimer le restaurant {name}\u00A0?',
        'kingdom.profile.form.optins.title': 'Mes exigences',
        'kingdom.profile.form.optins.get.error':
            'Service momentanément indisponible, veuillez réessayer ultérieurement.',
        'kingdom.profile.form.optins.local':
            "E-mail sur l'actualité et les offres de mes restaurants fréquentés.",
        'kingdom.profile.form.optins.national':
            "E-mail sur l'actualité, les nouveautés et les offres Burger King® France.",
        'kingdom.profile.form.optins.actuality':
            'E-mail sur mes offres et les actualités de mon compte Kingdom.',
        'kingdom.profile.form.optins.sms':
            'SMS sur les offres Burger King® France (deux fois par mois maximum).',
        'kingdom.profile.form.optins.push.auth':
            'Notification Push sur les actualités de mon compte Kingdom et les bons plans.',
        'kingdom.profile.form.optins.push.auth.mention':
            'Ce mode de communication est actif sous condition que vous ayez autorisé les notifications Burger King France dans les ',
        'kingdom.profile.form.optins.push.auth.mention.link':
            'Réglages de votre téléphone',
        'kingdom.profile.form.optins.push':
            'Notification Push sur les actualités et les bons plans.',
        'kingdom.profile.form.success':
            'Merci, votre profil a bien été mis à jour.',
        'kingdom.profile.form.button.save': 'Enregistrer',
        'kingdom.profile.form.button.add': 'Ajouter',
        'kingdom.profile.form.delete.message':
            'Cette opération est définitive, souhaitez-vous vraiment supprimer votre compte\u00A0?',
        'kingdom.profile.form.delete.account.title': 'Suppression de compte',
        'kingdom.profile.form.delete.account.infos':
            'En supprimant votre compte, vous supprimerez également toutes ses données associées (couronnes disponibles, préférences, informations personnelles)',
        'kingdom.profile.form.delete.account.firstname': 'Prénom',
        'kingdom.profile.form.delete.account.lastname': 'Nom',
        'kingdom.profile.form.delete.account.email': 'Email',
        'kingdom.profile.form.delete.account.phone': 'Téléphone',
        'kingdom.profile.form.delete.account.birthdate': 'Date de naissance',
        'kingdom.profile.form.delete.account.kingdomId': 'ID Kingdom',
        'kingdom.profile.form.delete.account.crownNumber.label':
            'Solde de couronnes',
        'kingdom.profile.form.delete.account.crownNumber':
            '{crownNumber} {crownNumber, plural, one {couronne} other {couronnes}}',
        'kingdom.profile.form.delete.account.button.confirm':
            'Supprimer mon compte',
        'kingdom.profile.form.cards.info1':
            'Vous pouvez enregistrer vos cartes au moment du paiement en cliquant sur la coche d’enregistrement.',
        'kingdom.profile.form.cards.info2':
            'Si vous avez trois cartes et souhaitez en ajouter une nouvelle, vous devez en supprimer une au préalable.',
        'kingdom.profile.form.cards.none':
            "Vous n'avez pas de carte enregistrée. Pensez à enregistrer votre carte lors de votre prochain paiement.",
        'kingdom.profile.form.cards.delete':
            'Êtes-vous sûr de vouloir supprimer cette carte de votre profil\u00A0?',
        'kingdom.profile.form.unsaved':
            'Êtes-vous sûr(e) de vouloir quitter cette page\u00A0? Vos modifications ne seront pas sauvegardées sans clic sur le bouton “Enregistrer” en bas de page.',
        'kingdom.profile.button.delete.account': 'Supprimer mon compte',
        'kingdom.profile.button.get.data': 'Demander mes données',
        'kingdom.delete.profile.error':
            'Une erreur est survenue lors de la suppression de votre profil, merci de réessayer ultérieurement.',
        'kingdom.card.title.breadcrumb.end': '\u00A0>\u00A0Ma carte Kingdom',
        'kingdom.card.description': 'Vous ne pourrez plus vous en passer',
        'kingdom.card.content':
            'Présentez le QR code ci-dessus en borne ou en caisse pour vous identifier et profiter de vos privilèges. A utiliser sans modération\u00A0!',
        'kingdom.card.alreadyHaveCard.title':
            'Vous avez déjà une carte Kingdom\u00A0?',
        'kingdom.card.alreadyHaveCard.description':
            "Renseignez le code présent au dos de la carte qui vous a été délivrée en restaurant pour l'associer à votre compte Burger King.",
        'kingdom.card.alreadyHaveCard.button': 'Associer ma carte',
        'kingdom.card.form.success':
            'Merci, nous avons bien enregistré votre carte de fidélité.',
        'kingdom.challenges.title.breadcrumb.end': '\u00A0>\u00A0Mes blasons',
        'kingdom.challenges.blazon.cta.label': 'Voir mes coupons',
        'kingdom.challenges.tuto.description.1':
            'Chaque blason propose un défi à relever.',
        'kingdom.challenges.tuto.description.2':
            'Quand le défi est réalisé, le blason est débloqué. Et là, vous remportez un avantage, à la hauteur de vos efforts.',
        'kingdom.challenges.tuto.levels.bronze': 'Bronze',
        'kingdom.challenges.tuto.levels.silver': 'Argent',
        'kingdom.challenges.tuto.levels.gold': 'Or',
        'kingdom.challenges.tuto.reward.points': 'Des couronnes',
        'kingdom.challenges.tuto.reward.privileges': 'Des coupons',
        'kingdom.challenges.tuto.reward.description':
            "Certaines récompenses vous proposent même de choisir entre l'un ou l'autre. Et là, la décision royale vous appartient.",
        'kingdom.challenges.tuto.cta': 'À vous de jouer',
        'kingdom.challenge.expiration.title': 'Date de validité',
        'kingdom.challenge.coupon.associated.blazon': 'Blason associé',
        'kingdom.challenge.rewards.title': 'Récompenses',
        'kingdom.challenge.reward.points': '{points} couronnes',
        'kingdom.challenge.reward.label.single': 'À gagner\u00A0:',
        'kingdom.challenge.reward.label.multiple': 'À gagner, au choix\u00A0:',
        'kingdom.challenge.reward.error.not.found':
            'Désolé, le blazon ou privilège est introuvable.',
        'kingdom.challenge.reward.success.points':
            'Vous avez débloqué {values} couronnes',
        'kingdom.challenge.unlocked.button': 'Libérez votre avantage',
        'kingdom.challenge.reward.modal.title':
            'La décision royale vous appartient, vous avez le choix\u00A0:',
        'kingdom.add.blazon': 'Associer un blason',
        'kingdom.blazons.push.coupons.title':
            "Vos coupons n'attendent plus que vous\u00A0...",
        'kingdom.privilege.see.coupon': 'Voir le coupon',
        'kingdom.privilege.select.coupon': 'Sélectionner',
        'kingdom.privileges.tuto.description.1':
            'Chaque coupon donne accès à un code de réduction\u00A0: cliquez pour le découvrir\u00A0!',
        'kingdom.privileges.tuto.description.2':
            'Votre coupon de réduction est utilisable dans tout le royaume\u00A0:',
        'kingdom.privileges.tuto.drive.help': 'En voiture\u00A0?',
        'kingdom.privileges.tuto.drive.description':
            'Énoncez simplement votre numéro de coupon pour bénéficier de votre avantage',
        'kingdom.privileges.tuto.drive': 'En drive',
        'kingdom.privileges.tuto.cashregister': 'En caisse',
        'kingdom.privileges.tuto.borne': 'En borne',
        'kingdom.blazons.push.coupons.description':
            'Vous avez {nbCoupons} {nbCoupons, plural, one {coupon} other {coupons}} en attente',
        'kingdom.blazons.push.coupons.button': 'Accéder à mes coupons',
        'kingdom.blazons.gain.label': 'Privilèges à gagner\u00A0:',
        'kingdom.privileges.title.breadcrumb.end': '\u00A0>\u00A0Mes coupons',
        'kingdom.privileges.coupon.icon.label': 'AVANTAGE ROYAL',
        'kingdom.privileges.coupon.validity.label': 'Valable jusqu’au {date}',
        'kingdom.privileges.coupon.validity': 'Jusqu’au {date}',
        'kingdom.privileges.coupon.restaurant.label':
            'Valable dans les restaurants participants*',
        'kingdom.privileges.coupon.modal.restaurants':
            'Liste des restaurants participants\u00A0:',
        'kingdom.privileges.coupon.modal.zoom.restaurants':
            'Voir la liste des restaurants participants',
        'kingdom.privileges.coupon.stamp.BURNED': 'Victime de votre faim',
        'kingdom.privileges.coupon.stamp.EXPIRED': 'Coupon expiré',
        'kingdom.privileges.coupon.stamp.UNAVAILABLE': 'Coupon indisponible',
        'kingdom.points.offer.unavailable': 'Produit indisponible',
        'kingdom.privileges.coupon.modal.zoom.code': 'Code\u00A0:\u00A0{id}',
        'kingdom.privileges.coupon.modal.zoom.drive': 'Obtenir mon code drive',
        'kingdom.privileges.coupon.modal.zoom.claim': 'Réclamer mon gain',
        'kingdom.privileges.coupon.digital.cta': 'Récupérer mon gain',
        'kingdom.privileges.coupon.eligibility.all': 'Tous les restaurants',
        'kingdom.privileges.coupon.eligibility.multiple':
            '{restaurantNumber} {restaurantNumber, plural, one {restaurant} other {restaurants}}',
        'kingdom.privileges.push.coupons.empty.title':
            "Oups\u00A0!\u00A0Vous n'avez pas encore de coupons\u00A0!",
        'kingdom.no.privileges.title':
            'Vous n’avez aucun coupon pour le moment.',
        'kingdom.push.challenges.button': 'Afficher les défis à relever',
        'kingdom.privileges.push.coupons.more.title':
            "Encore plus d'offres\u00A0?",
        'kingdom.privileges.push.coupons.more.description':
            'Relevez nos défis et gagnez de nouveaux blasons\u00A0!',
        'kingdom.privileges.push.coupons.more.button': 'Voir les défis',
        'kingdom.privileges.input.title': 'Ajoutez un code promo Kingdom',
        'kingdom.privileges.input.placeholder': 'Entrez un code Kingdom',
        'kingdom.privileges.form.title':
            'Vous avez déniché un coupon Kingdom\u00A0?',
        'kingdom.privileges.form.baseline': 'Saisissez votre code',
        'kingdom.privileges.form.placeholder': 'Saisissez votre code',
        'kingdom.privileges.form.success':
            'Votre code promo a bien été pris en compte.',
        'kingdom.logout.button.local.label': 'Déconnexion',
        'kingdom.logout.button.global.label':
            'Déconnexion de tous les appareils',
        'kingdom.logout': 'Se déconnecter',
        'kingdom.faq': 'Découvrir notre FAQ',
        'kingdom.points.count.title': 'Ma collection de couronnes',
        'kingdom.points.count.button': 'Convertir mes couronnes',
        'kingdom.points.renew': 'Renouveler la validité',
        'kingdom.points.renew.modal.title':
            'Souhaitez-vous prolonger la durée de validité de vos couronnes de 6 mois\u00A0?',
        'kingdom.orders.title.breadcrumb': '\u00A0>\u00A0Mes commandes',
        'kingdom.orders.display.all.link': 'Afficher toutes mes commandes',
        'kingdom.orders.display.all.loading.message':
            'Veuillez patientez, nous récupérons toutes vos commandes',
        'kingdom.fidelity.program.link':
            'En savoir plus sur le programme de fidélité Kingdom',
        'learn.more': "Plus d'infos",
        'legal.notice': 'Mentions légales',
        'form.ecommerce.mode.label': 'Mode de commande\u00A0:',
        'form.error.field.mandatory': 'Ce champ est obligatoire',
        'form.error.field.invalid': 'Le champ de saisie est invalide',
        'form.error.field.special.characters.forbidden':
            'Les caractères spéciaux ne sont pas acceptés',
        'form.civility.title.label': 'Vous êtes',
        'form.civility.label': 'Civilité',
        'form.civility.man': 'M.',
        'form.civility.woman': 'Mme',
        'form.civility.man.key': 'M',
        'form.civility.woman.key': 'F',
        'form.subject.title.label': 'Votre demande concerne :',
        'form.subject.kingdom.points': 'Vos points fidélité Kingdom',
        'form.subject.kingdom.other':
            'Un autre problème lié à votre programme fidélité Kingdom',
        'form.lastname.placeholder': 'Tapez ici votre nom',
        'form.firstname.title': 'Prénom*',
        'form.firstname.placeholder': 'Tapez ici votre prénom',
        'form.phone.placeholder': 'Tapez ici votre numéro de téléphone',
        'form.carcolor.placeholder': 'Tapez ici la couleur de votre voiture',
        'form.licenseplate.placeholder':
            "Tapez ici votre numéro de plaque d'immatriculation",
        'form.email.placeholder': 'Email (obligatoire)',
        'form.loyalty.placeholder': 'Tapez ici le numéro',
        'form.birthdate.title': 'Date de naissance*',
        'form.favorite.restaurant.title': 'Restaurant favori*',
        'form.arrival.time.title': "Heure d'arrivée*",
        'form.date.placeholder': 'JJ/MM/AAAA',
        'form.datetime.placeholder': 'JJ/MM/AAAA hh:mm',
        'form.time.placeholder': 'hh:mm',
        'form.button.cancel': 'Annuler',
        'form.button.valid': 'Valider',
        'form.delete.title': 'Attention',
        'form.delete.button.submit': 'Oui, supprimer',
        'form.delete.button.cancel': 'Noooooooooon\u00A0!',
        'form.mandatory.information': '*Mentions obligatoires',
        'form.kingdom.physical.agreements':
            'En complétant ce formulaire, j’accepte que mes données personelles soient transmises aux prestataires partenaires dans le cadre de l’opération “Coffre Royal”',
        'form.error.default':
            "Désolé, une erreur inattendue est survenue. Veuillez réessayer ultérieurement s'il vous plaît.",
        'form.error.default.retry':
            'Désolé, une erreur inattendue est survenue. Voulez-vous réessayer\u00A0?',
        'form.error.restaurant.not.found':
            "Désolé, mais le restaurant que vous essayez d'ajouter n'existe pas",
        'form.error.restaurant.already.favorited':
            'Ce restaurant est déjà votre restaurant favori',
        'form.error.phone.wrong.format':
            'Désolé, le numéro de téléphone que vous avez saisi est incorrect.',
        'form.error.login.already.used': 'Désolé, cet email est déjà utilisé.',
        'form.email.update.match.error':
            'Les deux e-mails ne correspondent pas',
        'form.error.regex.email':
            "L'adresse e-mail que vous avez renseignée ne respecte pas le format imposé. Celle-ci doit respecter le format suivant : xxxx@xxxx.xxx",
        'form.error.regex.licenceplate':
            "La plaque d'immatriculation que vous avez renseignée ne respecte pas le format imposé. Celle-ci doit comporter 7 caractères alphanumériques au minimum.",
        'form.error.regex.carcolor':
            'La couleur que vous avez renseignée ne respecte pas le format imposé. Celle-ci doit comporter 25 caractères au maximum.',
        'form.password.update.match.error':
            'Les deux champs de saisie du mot de passe ne correspondent pas',
        'form.error.regex.password':
            'Votre mot de passe ne respecte pas le format imposé. Votre mot de passe doit comporter 8 caractères au minimum, au moins 1 lettre majuscule, 1 caractère spécial (!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~) et un caractère numérique',
        'form.error.regex.loyalty': "Ce numéro n'est pas valide",
        'form.error.regex.expirationDate': 'La date doit être au format ##/##',
        'form.error.loyalty.already.used': 'Ce numéro est déjà utilisé',
        'form.error.loyalty.number.invalid': "Le code saisi n'est pas valide",
        'form.coupon.error.student.not.eligible':
            'Votre offre étudiante Le Bon Bail est déjà activée. Retrouvez votre coupon dans vos coupons Kingdom !',
        'form.coupon.error.operation.not.available':
            'L’offre n’est pas disponible.',
        'form.coupon.error.operation.no.longer.available':
            'L’offre n’est plus disponible.',
        'form.coupon.error.operation.total.limit.reached':
            'L’offre a atteint la limite d’utilisation totale.',
        'form.coupon.error.operation.invalid.order.type':
            'L’offre n’est pas disponible sur ce canal de vente. Veuillez consulter les mentions légales.',
        'form.coupon.error.operation.invalid.restaurant':
            'L’offre n’est pas disponible dans ce restaurant.',
        'form.coupon.error.promotion.not.available.in.restaurant':
            'La promotion n’est pas disponible dans ce restaurant.',
        'form.coupon.error.product.not.available.in.restaurant':
            'Le produit associé à cette promotion n’est pas disponible. Veuillez réessayer ultérieurement.',
        'form.coupon.error.coupon.not.available.in.restaurant':
            'Ce coupon n’est pas disponible dans ce restaurant.',
        'form.coupon.error.invalid':
            'Le code saisi est invalide. Veuillez ressaisir votre code.',
        'form.coupon.error.not.available':
            'Désolé, le code promotion utilisé est indisponible',
        'form.coupon.error.expired':
            "Désolé, ce code promotion n'est plus valable",
        'form.coupon.error.already.used':
            'Ce code a déjà été utilisé. Veuillez saisir un autre code.',
        'form.coupon.error.already.coupon.used':
            'Ce coupon a déjà été utilisé. Veuillez en sélectionner un autre.',
        'form.coupon.error.not.eligible':
            "Vous n'êtes pas éligible à cette promotion. Veuillez consulter les mentions légales.",
        'form.coupon.error.leap.year.total.limit.reached':
            'Code déjà utilisé. Dommage, quelqu’un a été plus rapide que toi, réessaie dans 4 ans.',
        'form.coupon.error.not.authenticated':
            'Vous devez être connecté pour pouvoir utiliser cette offre',
        'form.coupon.error.drive.only':
            'Ce code est uniquement valable en drive.',
        'form.coupon.error.scan.limit.reached':
            'Vous avez atteint le nombre maximal de scans par jour.',
        'form.error.generic.message':
            "Désolé, une erreur inattendue est survenue. Veuillez réessayer ultérieurement s'il vous plaît.",
        'form.error.birthdate.invalid':
            'Désolé, la date de naissance de votre enfant est invalide.',
        'form.error.birthdate.wrong.format':
            'Désolé, la date de naissance de votre enfant ne correspond pas au format JJ/MM/AAAA.',
        'form.send.error.cgu':
            "Désolé, mais vous n'avez pas accepté les conditions générales d'utilisation.",
        'form.error.agreements.operation':
            'Veuillez accepter les conditions de l’opération pour pouvoir participer.',
        'form.button.send': 'Envoyer',
        'social.apple.button': 'Connexion avec Apple',
        'social.facebook.button': 'Facebook',
        'social.google.button': 'Google',
        'social.facebook.url':
            'https://www.facebook.com/burgerkingfranceofficiel/',
        'social.instagram.url': 'https://www.instagram.com/burgerkingfr',
        'social.tiktok.url': 'https://www.tiktok.com/@burgerkingfr',
        'social.twitter.url': 'https://twitter.com/BurgerKingFR',
        'social.facebook.url.re':
            'https://www.facebook.com/Burgerkingreunionofficiel/',
        'social.instagram.url.re':
            'https://www.instagram.com/burgerkingreunion',
        'social.tiktok.url.re': 'https://www.tiktok.com/@burgerkingreunion',
        'header.kingdom.popin.no.account.label':
            "Vous n'avez pas encore de compte\u00A0?",
        'header.kingdom.popin.signup.label': 'Rejoignez le kingdom',
        'insert.appName': 'Burger King® France',
        'insert.appName.reunion': 'Burger King® Réunion',
        'insert.price': 'GRATUIT',
        'insert.androidStore': 'Sur Google Play',
        'insert.iosStore': "Dans l'App Store",
        'insert.button': 'Ouvrir',
        'operation.generic.qrCode': 'Code : {code}',
        'operation.generic.tutorial.help': 'Comment obtenir mon offre\u00A0?',
        'operation.generic.tutorial.born.content':
            'Cliquez sur la rubrique "Une offre, un coupon\u00A0?" et scannez votre QR code (ou à défaut, rentrez le code à 7 caractères).',
        'operation.generic.tutorial.check.content':
            'Montrez votre code lors de la commande.',
        'operation.coupons.validity': '{label}\nle\u00A0{date}',
        'operation.choice.modal': 'Vous souhaitez :',
        'operation.choice.coupons': 'Afficher votre coupon',
        'operation.choice.cc': 'Commander en click and collect',
        'operation.choice': 'Accédez à votre offre',
        'operation.mystery.burger.share': 'Partager',
        'operation.random.coupon.congratulations.description':
            'Votre coupon est finalement offert',
        'operation.random.coupon.addedToCard': 'Coupon ajouté à votre panier !',
        'operation.random.coupon.notWinner.title': 'Bon appétit !',
        'operation.random.coupon.notWinner.description':
            'La prochaine fois ça sera peut-être offert',

        'operation.mystery.burger.options.choice': 'Choisissez votre option',
        'operation.mystery.burger.options.choice.meat': 'Boeuf ou Poulet',
        'operation.mystery.burger.options.choice.veggie': 'Veggie',
        'operation.mystery.burger.options.choice.confirm':
            'Êtes-vous sûr de votre choix ?',
        'operation.mystery.burger.options.choice.confirm.detail':
            'Une fois le coupon ajouté à votre panier, votre choix ne pourra plus être modifié.',
        'operation.mystery.burger.options.cant-change':
            "L'autre option a déjà été ajoutée à votre panier",
        'operation.mystery.burger.valid.until':
            'Valable jusqu‘au {expirationDate}',
        'operation.mystery.burger.order': 'Commander sur l‘app',
        'operation.mystery.burger.get.drive.code': 'Obtenir mon code drive',
        'operation.mystery.burger.my.drive.code': 'Mon code drive: ',
        'operation.mystery.burger.legal.information':
            'Informations & mentions legales',
        'operation.mystery.burger.how.to.use': 'Comment utiliser mon offre',
        'operation.mystery.burger.how.to.use.content':
            'TODO: Ajouter le contenu',
        'operation.burger-mystere.tutorial.help':
            'Comment obtenir mon burger mystère ou ma glace mystère\u00A0?',
        'operation.tutorial.born.title': 'SUR LA BORNE',
        'operation.burger-mystere.tutorial.born.content':
            'Cliquez sur la rubrique BURGER MYSTERE et scannez votre QR code (ou à défaut, rentrez le code à 7 caractères).',
        'operation.tutorial.check.title': 'AU COMPTOIR',
        'operation.burger-mystere.tutorial.check.content':
            'Montrez votre CODE MYSTERE lors de la commande.',
        'operation.tutorial.drive': 'Code drive\u00A0: ',
        'operation.tutorial.drive.content':
            'Cliquez sur « En drive\u00A0? » et donnez le code DRIVE à l’équipier lors de votre commande.',
        'operation.tutorial.delivery.cc':
            'Et sinon, vous pouvez aussi les commander directement en CLICK AND COLLECT',
        'operation.burger-mystere.tutorial.legals':
            'Prix max. conseillé – Hors livraison. Jusqu’au 08/07/19 dans la limite de 2/jour et des stocks de produits disponibles, sur présentation obligatoire de l’app. Burger King France  – modalités et restaurants participants sur\u00A0',
        'operation.burger-mystere.title':
            'Burger Mystère, c’est l’un de nos 10 Burgers au hasard pour 2€ seulement',
        'operation.glace-mystere.title':
            'Glace Mystère c’est l’un de nos 5 KING FUSION au hasard pour 2€ seulement',
        'operation.tutorial.legals.link': 'https://www.burgerking.fr/',
        'operation.tutorial.legals.link.text': 'www.burgerking.fr',
        'operation.coupons.help.first': '1.\u00A0Prépare ton app avec ton code',
        'operation.coupons.help.two': '2.\u00A0Présente le lors de ta commande',
        'operation.coupons.code.restaurant': 'Votre code en restaurant\u00A0:',
        'operation.coupons.button.restaurant': 'En restaurant\u00A0?',
        'operation.coupons.button.drive': 'En drive\u00A0?',
        'operation.coupons.code.drive': 'Votre code en drive\u00A0:',
        'operation.coupons.burned.title': 'Ce coupon a été utilisé',
        'operation.burger-mystere.coupons.burned.label':
            'Revenez demain pour profiter à nouveau de votre burger mystère.',
        'operation.democratic-burger.tutorial.help':
            'Comment obtenir mon democratique burger\u00A0?',
        'operation.democratic-burger.tutorial.born.content':
            'Cliquez sur la rubrique DÉMOCRATIQUE BURGER et scannez votre QR code (ou à défaut, rentrez le code à 7 caractères).',
        'operation.democratic-burger.tutorial.check.content':
            'Montrez votre code DÉMOCRATIQUE BURGER lors de la commande.',
        'operation.democratic-burger.tutorial.legals':
            'Prix max. conseillé. Hors livraison. Limité à 2 Démocratiques Burgers par jour. Jusqu’au 06/10/19 dans la limite des stocks de produits disponibles et sur présentation obligatoire de l’app. Modalités et restaurants participants sur\u00A0',
        'operation.democratic-burger.coupons.burned.label':
            'Revenez demain pour profiter à nouveau de votre démocratique burger.',
        'operation.impersonal.card.promo.title': 'Un coupon, une promo\u00A0?',
        'operation.impersonal.card.promo.subtitle':
            'Retrouvez tous vos coupons et profitez des offres spéciales du moment',
        'operation.impersonal.modal.title': 'Saisir un code promo',
        'operation.impersonal.modal.bal2promo':
            'Pour profiter de Bal de promos, rendez-vous sur l’app Burger King',
        'operation.impersonal.modal.bk.days':
            'Pour profiter des BK Days, rendez-vous sur l’app Burger King',
        'operation.impersonal.modal.operation.repeat':
            'Pour profiter de “Coup de flamme à Hotting Grill”, rendez-vous sur l’app Burger King France',
        'operation.impersonal.modal.mystery.burger':
            'Pour profiter de Burger Mystère, rendez vous sur l’app !',
        'operation.impersonal.form.title':
            'Vous avez déniché un code promo\u00A0?',
        'operation.agreements.link': "conditions de l'opération\n",
        'restaurant.hours.label': 'VOIR LES HORAIRES',
        'restaurant.room': 'Salle',
        'restaurant.drive': 'Drive',
        'restaurant.news.title': "Faim d'actus\u00A0?",
        'restaurant.jobs.title': 'Vous avez la passion, nous avons la flamme',
        'restaurant.jobs.button': "Voir les offres d'emploi",
        'restaurant.jobs.url': 'https://emploi.burgerking.fr',
        'restaurant.offers.title': 'Offres valables dans ce restaurant',
        'restaurant.offers.mail.label':
            'Renseignez ce champ pour recevoir vos coupons par mail',
        'restaurant.offers.applications.label':
            "Ou retrouvez-les directement sur l'application BURGER KING",
        'restaurant.form.not.found':
            "Desolé, mais il est impossible de récupérer des coupons sur ce restaurant car il n'existe pas",
        'restaurant.offfers.not.allowed':
            "Désolé, mais vous n'êtes pas autorisé à récupérer des coupons pour ce restaurant.",
        'restaurant.offfers.suscribe.success':
            'Rendez-vous dès maintenant dans vos mails afin de profiter des offres de votre restaurant.',
        'restaurant.offers.none':
            'Aucune offre disponible dans ce restaurant en ce moment',
        MONDAY: 'Lundi',
        TUESDAY: 'Mardi',
        WEDNESDAY: 'Mercredi',
        THURSDAY: 'Jeudi',
        FRIDAY: 'Vendredi',
        SATURDAY: 'Samedi',
        SUNDAY: 'Dimanche',
        JANUARY: 'Janvier',
        FEBRUARY: 'Février',
        MARCH: 'Mars',
        APRIL: 'Avril',
        MAY: 'Mai',
        JUNE: 'Juin',
        JULY: 'Juillet',
        AUGUST: 'Août',
        SEPTEMBER: 'Septembre',
        OCTOBER: 'Octobre',
        NOVEMBER: 'Novembre',
        DECEMBER: 'Décembre',
        'notation.button.disapointed': 'Je suis déçu',
        'notation.button.like': "J'aime",
        'notation.message.disapointed':
            "Aidez-nous à optimiser l'application, donnez-nous votre avis",
        'notation.button.disapointed.send': 'Donner mon avis',
        'notation.button.disapointed.no': 'Non, merci',
        'notation.message.think':
            'Que pensez-vous de votre application BURGER\u00A0KING® France\u00A0?',
        'notation.form.baseline': 'Que voulez-vous partager avec nous\u00A0?',
        'notation.form.explanation': 'Expliquez-nous*',
        'notation.form.category.placeholder': 'Sélectionner une catégorie*',
        'notation.form.type.enhance': "Suggestion d'amélioration",
        'notation.form.type.trouble': 'Problème technique',
        'notation.form.other':
            'Pour toute autre remarque, nous vous invitons à contacter notre Service Client sur notre site ou notre application.',
        'notation.message.disapointed.success':
            "Merci d'avoir noté l'application.",
        'notation.button.disapointed.success': 'ok',
        percentage: '{percentage}%',
        help: 'Comment ça marche\u00A0?',
        'help.kingdom': "Tout sur l'identification",
        'help.privileges': 'Tout sur les coupons',
        'help.crown': 'Tout sur mes couronnes',
        'help.challenges': 'Tout sur les blasons',
        'help.points': 'Récupérer mes produits offerts',
        or: 'ou',
        'widget.restaurant.label.offers': 'Offres en cours',
        'birthday.title': 'Pré-réservation royale',
        'birthday.breadcrumb': '\u00A0>\u00A0Anniversaire',
        'birthday.description':
            'Afin d’organiser un anniversaire pour vos petits rois et reines, nous avons besoin de plusieurs informations pour que le restaurant puisse vous recontacter et finaliser la réservation.',
        'birthday.disabled':
            'Le service de pré-réservation d’anniversaire est momentanément suspendu.',
        'birthday.form.restaurant.title': 'Trouver un restaurant',
        'birthday.form.restaurant.name': 'Choix du BURGER KING®*',
        'birthday.form.restaurant.name.placeholder':
            'Recherchez une ville ou un restaurant...',
        'birthday.form.restaurant.date': 'Date et heure souhaitées*',
        'birthday.form.restaurant.date.invalid':
            "La réservation n'est pas disponible sur ce créneau",
        'birthday.form.restaurant.guests':
            "Nombre d'enfants (incluant l'enfant fêté)*",
        'birthday.form.gift.title': 'Le cadeau royal',
        'birthday.form.gift.name': 'Choix du cadeau*',
        'birthday.form.gift.cake': 'Choix du gâteau*',
        'birthday.form.kid.title': 'Le roi/la reine de la fête',
        'birthday.form.kid.name': 'Prénom du roi ou de la reine*',
        'birthday.form.kid.name.placeholder':
            'Tapez ici le prénom de votre enfant',
        'birthday.form.kid.birthdate.error':
            "L'âge de votre enfant doit être compris entre 4 et 13ans",
        'birthday.form.kid.parent.email': 'E-mail du parent organisateur*',
        'birthday.form.kid.parent.phone': 'Téléphone du parent organisateur*',
        'birthday.form.kid.comments': 'Remarques',
        'birthday.form.kid.comments.error':
            'Vos remarques ne doivent pas dépasser {limit} caractères.',
        'birthday.form.kid.comments.placeholder':
            'Évoquez ici toute allergie, handicap, voeux pieux...',
        'birthday.form.price': 'Coût de la fête\u00A0:\u00A0{price}\u00A0€',
        'birthday.form.price.infos':
            "{unitPrice}\u00A0€/enfant. Prix indicatif susceptible d'évoluer selon le restaurant sélectionné, au moment du paiement en caisse.",
        'birthday.form.button.submit': 'Confirmer ma demande de réservation',
        'birthday.form.optin.promo':
            'Je souhaite recevoir par email les nouveautés et bons plans Burger King® France.',
        'birthday.form.optin.cgu':
            "En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de ma demande de réservation d’un anniversaire et de la relation commerciale qui peut en découler.",
        'birthday.form.send.error.gift':
            "Désolé, le cadeau que vous avez choisi n'est pas disponible.",
        'birthday.form.send.error.cake':
            "Désolé, le gâteau que vous avez choisi n'est pas disponible.",
        'birthday.form.send.error.service':
            "Désolé, fêter l'anniversaire de votre enfant dans le restaurant selectionné est impossible pour le moment.",
        'birthday.form.send.error.guests':
            "Désolé, le nombre maximum d'enfants invités a été atteint.",
        'birthday.form.send.error.reservation.date.invalid':
            'Désolé, votre date de réservation est invalide.',
        'birthday.form.send.error.reservation.date.wrong.format':
            'Désolé, votre date de réservation est invalide ne correspond au format JJ/MM/AAAA hh:mm',
        'birthday.form.send.error.comments.limit':
            'Désolé, vos remarques dépassent la limite des {limit} caractères autorisés.',
        'birthday.form.send.success.title': 'Merci\u00A0!',
        'birthday.form.send.success.message':
            "Votre demande a bien été transmise à notre restaurant.\nNous reviendrons vers vous sous 48h pour confirmer l'évènement et éventuellement réviser la date et l’heure sélectionnée.",
        'birthday.form.send.success.button': "Retour à l'offre anniversaire",
        'birthday.form.legal.mentions.0':
            'Liste des allergènes dans le gâteau anniversaire : gluten, soja, lait de vache (y compris du lactose), œuf, fruits à coques et trace possible de sulfites. \n',
        'birthday.form.legal.mentions.1':
            'Les informations renseignées dans le présent formulaire sont enregistrées dans un fichier informatisé par la société Burger King France, domiciliée 34 Rue Mozart – Immeuble Le Cassiopée à Clichy (92110), en qualité de responsable de traitement, afin de gérer votre réservation et, le cas échéant avec votre consentement, de vous envoyer des communications du réseau Burger King®.\n' +
            'Les données marquées avec un astérisque dans le formulaire doivent obligatoirement être fournies. Dans le cas contraire, votre réservation ne pourra pas être prise en compte.\n' +
            'Les destinataires des données sont précisés à l’article 12 de notre politique de protection des données disponible sur ',
        'birthday.form.legal.mentions.2':
            '\nLes données sont conservées le temps d’organiser l’anniversaire au sein du restaurant Burger King® choisi par vos soins et, si vous avez accepté de recevoir des communications du réseau Burger King®, jusqu’à désinscription au travers de votre compte, ou par l’utilisation des liens de désabonnement prévus à cet effet dans nos envois.\n' +
            'Pour en savoir plus sur le traitement de vos données, vous pouvez consulter notre politique de protection des données disponible sur ',
        'birthday.form.legal.mentions.3':
            '\nVous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre droit à la limitation du traitement de vos données. S’agissant du traitement de vos données dans le cadre des envois de communications du réseau Burger King®, vous pouvez également retirer à tout moment votre consentement au traitement de vos données, ou vous y opposer, ou exercer votre droit à la portabilité de vos données.\n' +
            'Pour exercer ces droits ou pour toute question sur le traitement de vos données, vous pouvez contacter notre délégué à la protection des données à l’adresse électronique suivante : ',
        'birthday.form.legal.mentions.4':
            '\nSi vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL.',
        'king.birthday.title.start': "Un anniversaire c'est bien, un",
        'king.birthday.title.middle': 'anniversaire royal',
        'king.birthday.title.end': " c'est carrément mieux\u00A0!",
        'king.birthday.description.start':
            "Avec le King's Birthday, c'est que du bonheur pour les parents des cool kids puisque Burger King s'occupe de tout : Invitations, accueil des copains, animation, goûter et distribution de cadeaux\u00A0!",
        'king.birthday.description.end':
            "Et pour les enfants, c'est l'anniversaire de leurs rêves\u00A0:\u00A0une aventure chevaleresque avec des défis pour réussir à sauver des griffes de l'infâme Chokozorus...",
        'king.birthday.breadcrumb.end': "\u00A0>\u00A0King's birthday",
        'king.birthday.book.title':
            'Envie de surprendre vos enfants avec un anniversaire royal\u00A0?',
        'king.birthday.book.cta': 'Reservez votre anniversaire',
        'king.birthday.explanation.title.start': "Le King's birthday",
        'king.birthday.explanation.title.end': "\u00A0c'est quoi\u00A0?",
        'king.birthday.explanation.description':
            '1h45 de folie pour les enfants\u00A0...\u00A0et de sérénité pour les parents\u00A0!',
        'king.birthday.explanation.step1':
            'Une aventure fantastique avec 6 épreuves à réussir entre amis pour récupérer le gâteau volé par Chokozorus, le vilain dinosaure.',
        'king.birthday.explanation.step2':
            'Des surprises pour ses amis et un super cadeau pour votre enfant à choisir',
        'king.birthday.explanation.step3.one': 'Un goûter sucré ou salé',
        'king.birthday.explanation.step3.two': '+ une boisson de 20CL.',
        'king.birthday.explanation.step3.three':
            "+ Un gâteau d'anniversaire royal à partager.",
        'king.birthday.explanation.step3.cta': 'Voir le programme détaillé',
        'ecommerce.delivery': 'Livraison',
        'ecommerce.order.mode.choice': 'Choisissez votre mode de commande',
        'ecommerce.order.mode.choice.clickandcollect.description':
            'Votre commande à retirer au comptoir',
        'ecommerce.order.mode.choice.kingtable.description':
            'Vous êtes en restaurant ? Faites vous servir à table maintenant',
        'ecommerce.order.mode.choice.unvailable': 'Service indisponible',
        'ecommerce.order.unavailable': 'Commande temporairement indisponible',
        'ecommerce.restaurant.choice.no.results.title':
            'Aucun restaurant à proximité',
        'ecommerce.restaurant.choice.no.results.delivery':
            'Nous n’avons pas encore de restaurant proposant le service livraison autour de l’adresse renseignée.',
        'ecommerce.restaurant.choice.no.results.clickandcollect':
            'Nous n’avons pas encore de restaurant proposant le service click & collect autour de l’adresse renseignée. En attendant, étendez un peu votre recherche.',
        'ecommerce.order.recap': 'Récapitulatif de ma commande',
        'ecommerce.order.recap.date': '{date} à {time}',
        'ecommerce.order.prepared.by': 'Préparé par\u00A0:',
        'ecommerce.delivery.geolocation.required.message':
            'Afin d’assurer un service Livraison optimal, l’activation de votre géolocalisation est nécessaire. Si vous ne souhaitez pas activer la géolocalisation, vous devrez sélectionner un autre mode de commande.',
        'ecommerce.delivery.fine.geolocation.required.message':
            'Afin d’assurer un service Livraison optimal, l’activation de votre géolocalisation exacte est nécessaire. Si vous ne souhaitez pas activer la géolocalisation exacte, vous devrez sélectionner un autre mode de commande.',
        'ecommerce.delivery.geolocation.required.cancel':
            'Sélectionner un autre mode de commande',
        'ecommerce.delivery.restaurant.choice.title':
            'Sélectionnez votre adresse de livraison',
        'ecommerce.delivery.restaurant.search.placeholder':
            'Entrez une adresse de livraison',
        'ecommerce.delivery.restaurant.eta':
            '{lowerRangeArrival}\u00A0-\u00A0{higherRangeArrival}\u00A0min',
        'ecommerce.delivery.address': 'Adresse de livraison',
        'ecommerce.delivery.drop.off.instructions': 'Instructions de livraison',
        'ecommerce.delivery.drop.off.outside': "Livraison à l'extérieur",
        'ecommerce.delivery.drop.off.at.door': 'Livraison à ma porte',
        'ecommerce.delivery.drop.off.info':
            'Code, interphone, escaliers, étape...',
        'ecommerce.delivery.catalog.header.eta':
            'Livraison {lowerRangeArrival}\u00A0-\u00A0{higherRangeArrival}',
        'ecommerce.delivery.eta.title.delivering': "Heure d'arrivée estimée",
        'ecommerce.delivery.eta.title.delivered': 'Heure de livraison',
        'ecommerce.delivery.eta': '{lowerArrivalRange}-{higherArrivalRange}',
        'ecommerce.delivery.provider.mention': 'Livraison par',
        'ecommerce.delivery.follow.link': 'Suivre la livraison',
        'ecommerce.delivery.fees': 'Frais de livraison',
        'ecommerce.free.delivery.fees': 'Offerts',
        'ecommerce.delivery.error.cart.price.too.low':
            'Le montant minimum de commande de {value}€ hors frais de livraison n’est pas atteint.',
        'ecommerce.delivery.error.no.delivery.fees':
            'Une erreur est survenue lors de la récupération de vos frais de livraison, merci de réessayer ultérieurement.',
        'ecommerce.delivery.provider.mention.small': 'Livraison par',
        'ecommerce.delivery.delivered.by': 'Livreur\u00A0: {driverName}',
        'ecommerce.delivery.contact.driver': 'Contacter',
        'ecommerce.delivery.error.delivery.address.title':
            'L’adresse sélectionnée n’est pas assez précise',
        'ecommerce.delivery.error.delivery.address.description':
            'L’adresse sélectionnée n’est pas assez précise il vous faut sélectionner une adresse avec numéro de voie',
        'ecommerce.delivery.warning.user.too.far.title':
            'L’adresse sélectionnée est un peu loin de votre position',
        'ecommerce.delivery.warning.user.too.far.description':
            'L’adresse sélectionnée est à plus de 250m de votre position actuelle. Vérifiez l’adresse avant de continuer.',
        'ecommerce.delivery.warning.user.too.far.keep.address':
            'Conserver cette adresse',
        'ecommerce.delivery.warning.user.too.far.modify.address':
            'Modifier cette adresse',
        'ecommerce.discounts.kingdom.offers.footer.mention':
            'Les produits ci-dessus sont susceptibles de changer en fonction du restaurant sélectionné au moment de la commande',
        'ecommerce.logInModal.title': 'On vous connecte \u00A0?',
        'ecommerce.logInModal.continueWithKingdom': 'Continuer avec le Kingdom',
        'ecommerce.logInModal.continueWithoutKingdom': 'Continuer sans compte',
        'ecommerce.logInModal.explainKingdom':
            'Continuer avec un compte Kingdom pour cumuler des couronnes et utiliser vos avantages.',
        'ecommerce.order.download.receipt': 'Télécharger mon ticket',
        'ecommerce.order.download.succeed':
            'Votre ticket de caisse a été téléchargé',
        clickandcollect: 'Click & Collect',
        kingtable: 'King Table',
        'clickandcollect.map.select.restaurant': 'Sélectionner',
        'clickandcollect.order.start': 'Je déclenche la préparation',
        'clickandcollect.order.start.anyway': 'Je déclenche malgré tout',
        'clickandcollect.order.cancel': 'Annuler ma commande',
        'clickandcollect.order.cancel.title': 'Annulation de commande',
        'clickandcollect.order.cancel.question':
            'Êtes-vous sûr de vouloir annuler définitivement votre commande\u00A0?',
        'clickandcollect.order.start.description.takeaway':
            'Conseil\u00A0: Lancez la préparation de votre commande à votre arrivée dans le restaurant. Nous vous indiquons lorsqu’elle est prête (rdv sur la page d’accueil).',
        'clickandcollect.order.start.description.onsite':
            'Conseil\u00A0: Avant de déclencher votre commande, assurez-vous d’être à 5 MN du restaurant\u00A0!.',
        'clickandcollect.order.start.description.onsitetable':
            'Conseil\u00A0: Avant de déclencher votre commande, assurez-vous de récupérer votre numéro de chevalet en restaurant.',
        'clickandcollect.order.start.description.parking':
            'Astuce\u00A0: Les places sont facilement reconnaissables grâce au marquage au sol.',
        'clickandcollect.delivery.choice.title': 'Voulez-vous commander\u00A0?',
        'clickandcollect.delivery.choice.subtitle':
            'Votre mode de retrait\nClick & Collect',
        'clickandcollect.delivery.choice.takeaway': 'À emporter',
        'clickandcollect.delivery.choice.onsite': 'Sur place',
        'clickandcollect.delivery.choice.drive': 'Drive',
        'clickandcollect.delivery.choice.parking': 'Parking',
        'clickandcollect.delivery.choice.tableorder': 'King Table',
        'clickandcollect.delivery.choice.tableorder.withTable':
            'King Table - Table {table}',
        'clickandcollect.delivery.choice.takeaway.description':
            'Votre commande à emporter au comptoir',
        'clickandcollect.delivery.choice.onsite.description':
            'À consommer sur place',
        'clickandcollect.delivery.choice.drive.description':
            'Votre commande à retirer au drive à bord de votre véhicule',
        'clickandcollect.delivery.choice.parking.description':
            'Votre commande amenée à votre véhicule sur une place dédiée',
        'clickandcollect.delivery.choice.delivery': 'En livraison',
        'clickandcollect.choose.restaurant': 'Choisissez votre restaurant',
        'clickandcollect.search.placeholder': 'ENTREZ UN CODE POSTAL, VILLE...',
        'clickandcollect.search.restaurant.title':
            'Les restaurants autour de vous',
        'clickandcollect.search.restaurant.close':
            'Les restaurants les plus proches',
        'clickandcollect.search.restaurant.last':
            'Les derniers restaurants visités',
        'clickandcollect.search.restaurant.none':
            "Aucun restaurant n'est recherché",
        'clickandcollect.search.restaurant.error.fetch.catalog':
            "Nous n'avons pas pu récupérer les produits disponibles à la vente pour ce restaurant, veuillez réessayer ultérieurement.",
        'clickandcollect.error.fetch.catalog.restaurant':
            "Nous n'avons pas pu récupérer les produits disponibles à la vente pour le restaurant {resto}, voulez-vous réessayer\u00A0?",
        'clickandcollect.search.connect.title':
            "Vous n'êtes pas connecté\u00A0?",
        'clickandcollect.search.connect.description':
            'Identifiez-vous pour accéder directement à vos préférences et profiter de vos privilèges\u00A0!',
        'clickandcollect.search.connect.button': 'Me connecter',
        'clickandcollect.search.subscribe.button': "M'inscrire",
        'cart.order.rejected':
            'Votre commande a été rejectée. Merci de réessayer ultérieurement',
        'clickandcollect.cart.new.card.applepay.selected':
            'Paiement via Apple Pay sélectionné.',
        'clickandcollect.cart.new.card.googlepay.selected':
            'Paiement via Google Pay sélectionné.',
        'clickandcollect.cart.step.1': 'Panier',
        'clickandcollect.cart.step.2': 'Identification\u00A0&\u00A0Paiement',
        'clickandcollect.cart.step.3': 'Confirmation',
        'clickandcollect.cart.footer': 'Valider le panier\u00A0•\u00A0{price}',
        'clickandcollect.cart.footer.no.price': 'Valider le panier',
        'clickandcollect.cart.footer.items':
            '{number} {number, plural, =0 {article} one {article} other {articles}}',
        'clickandcollect.cart.return.catalog': 'Continuer mes achats',
        'clickandcollect.validate.cart.footer':
            'Valider mon panier • {finalPrice}',
        'clickandcollect.validate.cart.footer.no.price': 'Valider mon panier',
        'clickandcollect.cart.congrats': 'Bravo\u00A0!',
        'clickandcollect.cart.points.connected': 'Vous allez cumuler ',
        'clickandcollect.cart.points.not.connected':
            'Après votre inscription / connexion,\nvous auriez cumulé ',
        'clickandcollect.cart.subtotal': 'Sous total',
        'clickandcollect.cart.total': 'Total',
        'clickandcollect.cart.confirmation': 'Confirmation',
        'clickandcollect.cart.confirmation.kingtable.title':
            'King Table - Table {table}',
        'clickandcollect.cart.confirmation.kingtable.subtitle':
            'Votre commande servie à table',
        'clickandcollect.cart.delete':
            'Êtes-vous sûr de vouloir supprimer cet article de votre panier\u00A0?',
        'clickandcollect.cart.customize': 'Personnaliser',
        'clickandcollect.cart.custo.extra':
            '{qty, plural, one {Extra} other {{qty}x Extra}} {product}',
        'clickandcollect.cart.custo.without': 'Sans {product}',
        'clickandcollect.cart.empty':
            'Votre panier est vide. Et votre ventre aussi\u00A0!',
        'clickandcollect.cart.error.minimum':
            "Le montant de votre panier doit être d'au moins {value, plural, one {{value} euro} other {{value} euros}}",
        'clickandcollect.cart.error.maximum':
            'Le montant de votre panier est trop élevé',
        'clickandcollect.payment.secured': 'Paiement 100% sécurisé',
        'clickandcollect.product.footer': 'Ajouter au panier',
        'clickandcollect.product.footer.price':
            'Ajouter au panier\u00A0•\u00A0{price}',
        'clickandcollect.product.footer.personalize': 'Valider',
        'clickandcollect.discounts.footer': 'Valider la sélection',
        'clickandcollect.catalog.sauce':
            'Une sauce pour votre accompagnement\u00A0?',
        'clickandcollect.catalog.start.selection': 'Commencez votre sélection',
        'clickandcollect.catalog.last.order': 'Réutiliser ma dernière commande',
        'clickandcollect.catalog.use.last.order': 'Je réutilise la commande',
        'clickandcollect.catalog.trigger.order.again.alert':
            'Votre panier contient déjà une commande {ecommerceMode}. Êtes-vous sûr de vouloir la remplacer par une nouvelle commande\u00A0?',
        'clickandcollect.catalog.trigger.order.again':
            'Réutiliser cette commande',
        'clickandcollect.catalog.trigger.order.again.new':
            'Je commande à nouveau',
        'clickandcollect.last.order.missing.products.title': 'Information',
        'clickandcollect.last.order.missing.products':
            'Certains produits de votre précédente commande ne sont pas disponibles',
        'clickandcollect.last.order.missing.all.products':
            'Tous les produits de votre précédente commande sont indisponibles',
        'clickandcollect.catalog.filter.bacon': 'SANS BACON',
        'clickandcollect.catalog.kingdom.advantages': 'Mes avantages',
        'clickandcollect.catalog.kingdom.connection': 'Connexion',
        'clickandcollect.catalog.kingdom.connect': 'Connectez-vous',
        'clickandcollect.catalog.kingdom': 'Kingdom',
        'clickandcollect.catalog.kingdom.inactive':
            'Le programme Kingdom n’est pas disponible dans ce restaurant',
        'clickandcollect.catalog.crown.number':
            'En ce moment, vos couronnes sont {quantity} avec votre programme Kingdom',
        'clickandcollect.catalog.crown.number.double': 'doublées',
        'clickandcollect.catalog.crown.number.triple': 'triplées',
        'clickandcollect.catalog.crown.number.quadruple': 'quadruplées',
        'clickandcollect.catalog.menu.size':
            'Choisissez le format de votre menu',
        'clickandcollect.catalog.menu.size.small': '(S)',
        'clickandcollect.catalog.menu.size.medium': '(M)',
        'clickandcollect.catalog.menu.size.large': '(L)',
        'clickandcollect.catalog.menu.size.extra.large': '(XL)',
        'clickandcollect.catalog.menu.options': 'Ajoutez votre touche perso',
        'clickandcollect.catalog.menu.step': 'Et comme {name}\u00A0?',
        'clickandcollect.catalog.menu.sideorder':
            'Et comme accompagnement\u00A0?',
        'clickandcollect.catalog.menu.drink': 'Et pour votre boisson\u00A0?',
        'clickandcollect.catalog.menu.other': 'Et autre chose\u00A0?',
        'clickandcollect.catalog.product.personalize':
            'Personnalisez davantage',
        'clickandcollect.catalog.options.more': "Afficher plus d'options",
        'clickandcollect.catalog.product.personalize.category.ICE_CREAM':
            'Sélectionner votre glace',
        'clickandcollect.catalog.product.personalize.category.GLAZING':
            'Sélectionner votre nappage',
        'clickandcollect.catalog.product.personalize.category.TOPPING':
            'Sélectionner votre topping',
        'clickandcollect.catalog.product.personalize.uniqueChoice':
            'Sélectionner un élément parmi le groupe suivant',
        'clickandcollect.catalog.product.personalize.less': 'Réduire',
        'clickandcollect.catalog.product.infos': 'Infos produit',
        'clickandcollect.catalog.stepper.price': 'Extra {price}',
        'clickandcollect.catalog.drink.with.ice': 'Avec glaçons',
        'clickandcollect.catalog.drink.no.ice': 'Sans glaçons',
        'clickandcollect.catalog.modal.freeHotDrink.title':
            'Une boisson chaude offerte',
        'clickandcollect.catalog.modal.freeHotDrink.description':
            "C'est pour nous, c'est cadeau. Pour vous remercier d'utiliser le service King Table, on vous offre une boisson chaude* ! Ça vous chauffe ?",
        'clickandcollect.catalog.modal.freeHotDrink.condition':
            '*à partir de 1€ de commande. **Sous réserve des stocks disponibles en restaurant.',
        'clickandcollect.userinfos.footer': 'Valider et payer',
        'clickandcollect.userinfos.firstname': 'Prénom*',
        'clickandcollect.userinfos.firstname.optional': 'Prénom',
        'clickandcollect.userinfos.lastname': 'Nom*',
        'clickandcollect.userinfos.phone': 'Téléphone*',
        'clickandcollect.userinfos.email.info':
            'Votre adresse mail est modifiable depuis votre profil',
        'clickandcollect.userinfos.carcolor': 'Couleur de voiture',
        'clickandcollect.userinfos.carcolor.mandatory': 'Couleur de voiture*',
        'clickandcollect.userinfos.licenseplate.number':
            "Plaque d'immatriculation",
        'clickandcollect.userinfos.licenseplate.number.mandatory':
            "Plaque d'immatriculation*",
        'clickandcollect.userinfos.licenseplate.enroll':
            "Enregistrer mon numéro de plaque d'immatriculation",
        'clickandcollect.userinfos.applePay': 'Payer avec ',
        'clickandcollect.userinfos.cgv.start':
            'En passant commande, vous acceptez l’intégralité de nos ',
        'clickandcollect.userinfos.cgv.link': 'CGV',
        'clickandcollect.userinfos.cgv.error':
            'Veuillez accepter les Conditions Générales de Vente pour pouvoir poursuivre votre commande.',
        'clickandcollect.userinfos.continue': 'Continuer sans compte',
        'clickandcollect.confirmation.subtitle':
            'Votre commande n°{id} est validée.',
        'clickandcollect.confirmation.subtitle.drive': 'Votre commande',
        'clickandcollect.confirmation.description.onsitetable':
            'Vous avez choisi {collectMode} dans un restaurant qui propose le service à table\u00A0! Déclenchez la préparation de votre commande lors de votre arrivée en restaurant, lorsque vous aurez récupéré votre numéro de chevalet.',
        'clickandcollect.confirmation.description.general':
            'Vous avez choisi {collectMode}. C’est VOUS qui déclenchez la préparation de votre commande, lors de votre arrivée en restaurant.',
        'clickandcollect.confirmation.description.parking':
            'Vous avez choisi le mode de retrait {collectMode}. C’est VOUS qui devez déclencher la préparation de votre commande, lorsque vous êtes à 5 MN d’arriver sur le parking de votre restaurant.\nDes places signalées seront à votre disposition.',
        'clickandcollect.confirmation.description.parking.geoloc':
            'Vous avez choisi le mode de retrait {collectMode}. Vous pourrez déclencher la préparation de votre commande une fois géo-localisé à proximité de votre restaurant.\nDes places signalées seront à votre disposition.',
        'clickandcollect.confirmation.takaway':
            'Présentez-vous à l’équipier, au comptoir de retrait, dès que votre commande passe en statut «\u00A0commande prête\u00A0».',
        'clickandcollect.confirmation.onsite':
            'Patientez tranquillement à table pendant la préparation de votre commande.',
        'clickandcollect.confirmation.tableorder':
            'Patientez tranquillement à table pendant la préparation de votre commande.',
        'clickandcollect.confirmation.description.drive':
            'Lors de votre arrivée au drive, indiquez simplement votre numéro de commande à l’équipier.',
        'clickandcollect.confirmation.drive':
            'Rendez-vous simplement au drive pour retirer votre commande.',
        'clickandcollect.confirmation.parking':
            'Rendez-vous simplement sur les places dédiées dans votre restaurant, on vous sert\u00A0!',
        'clickandcollect.confirmation.description.tableorder':
            'Vous avez choisi d’être servi à table\u00A0: Surveillez l’avancement de votre commande depuis cette page.',
        'clickandcollect.pickupinfo.tableorder': 'Table {pickUpInfo}',
        'clickandcollect.confirmation.footer':
            'Une question\u00A0? Une déclaration\u00A0? \nContactez-nous\u00A0!',
        'clickandcollect.confirmation.alreadyClicked':
            'Vous avez déjà déclenché la préparation de cette commande',
        'clickandcollect.pay': 'Payer',
        'clickandcollect.payment.choice': 'Mes cartes enregistrées',
        'clickandcollect.payment.description':
            'Parce qu’un burger est bien meilleur quand il est chaud, votre carte ne sera débitée que lorsque vous déclencherez la préparation de votre commande, dès lors que vous êtes à proximité du restaurant.',
        'clickandcollect.payment.cards': 'Mes cartes',
        'clickandcollect.payment.card.endingBy': 'Carte terminant par',
        'clickandcollect.payment.cards.validation':
            'Validation par votre banque',
        'clickandcollect.payment.cards.expiration': ' expire le ',
        'clickandcollect.payment.cards.expired': ' a expiré le ',
        'clickandcollect.payment.cards.new': 'Utiliser une nouvelle carte',
        'clickandcollect.payment.cards.save':
            'Enregistrer ma carte pour payer en un clic la prochaine fois.',
        'delivery.payment.lunch.card.unavailable':
            'Les titres restaurant dématérialisés ne sont pas autorisés pour le service en livraison',
        'payment.lunch.card.service.unavailable':
            'Mode de paiement non autorisé pour ce restaurant',
        'payment.lunch.card.service.unavailable.delivery':
            'Mode de paiement non autorisé pour ce type de commande',
        'clickandcollect.cards.cb': 'Carte bleue',
        'clickandcollect.cards.mealVoucher': 'Carte titre restaurant',
        'clickandcollect.error.missing':
            'Un ou plusieurs produits sont indisponibles.',
        'clickandcollect.error.price':
            'Le prix de votre commande a été mis à jour, merci de consulter celui-ci et valider de nouveau votre commande',
        'clickandcollect.error.validation':
            'Un problème est survenu lors de la validation de votre commande.',
        'clickandcollect.error.payment.validation':
            'Un problème est survenu lors de la validation de votre commande. Vous ne serez pas débité.',
        'clickandcollect.error.restaurant.closed':
            'Le restaurant que vous avez choisi est fermé.',
        'clickandcollect.error.promo':
            'Désolé, la promotion utilisée est invalide',
        'clickandcollect.error.abuse':
            'Ce montant de commande n’est pas autorisé',
        'clickandcollect.error.default': 'Erreur inattendue',
        'clickandcollect.error.closed':
            'Le service Click & Collect du restaurant sélectionné est actuellement indisponible',
        'clickandcollect.error.closed.title':
            'Votre commande ne peut être déclenchée',
        'clickandcollect.error.too.far':
            'Pour déclencher votre commande, vous devez être à moins de {radius}m',
        'clickandcollect.error.too.far.message':
            'Si vous rencontrez un problème avec l’activation de votre commande, rendez-vous directement dans le restaurant.',
        'clickandcollect.payment.cancel.order': 'Annuler la commande',
        'clickandcollect.payment.error.message':
            'Un problème est survenu lors du paiement de votre commande. Vous ne serez pas débité.',
        'clickandcollect.payment.error.reason.cancelled':
            'Le paiement a été annulé.',
        'clickandcollect.payment.error.reason.refused':
            "Votre paiement n'a pas pu aboutir, merci de choisir un autre moyen de paiement.",
        'clickandcollect.payment.error.reason.table-order.bad-token':
            'Le QRcode scanné est invalide',
        'clickandcollect.payment.error.reason.error':
            'Une erreur est survenue lors du paiement, merci de réessayer ultérieurement.',
        'clickandcollect.back.home': "Retour à l'accueil",
        'clickandcollect.carttoast.addProduct':
            'Un produit a été ajouté à votre panier',
        'clickandcollect.cart.quit.title': 'Votre commande',
        'clickandcollect.cart.quit':
            "Etes vous sûr de vouloir quitter cette page et retourner à l'écran de commande\u00A0?",
        'clickandcollect.confirmation.table.title':
            'Vous avez choisi sur place',
        'clickandcollect.confirmation.table.message':
            'Renseignez votre numéro de chevalet récupéré en restaurant',
        'clickandcollect.confirmation.table.position':
            'Renseignez votre position en restaurant',
        'clickandcollect.confirmation.table.placeholder': 'Numéro de chevalet',
        'clickandcollect.confirmation.table.regex':
            'Votre numéro de table doit être composé de 1 à 3 chiffres.',
        'clickandcollect.confirmation.table.validate': 'Valider',
        'clickandcollect.confirmation.table.takeaway': 'Je préfère à emporter',
        'clickandcollect.confirmation.table.indoor': 'En salle',
        'clickandcollect.confirmation.table.terrace': 'En terrasse',
        'clickandcollect.confirmation.message':
            'Êtes-vous sûr de vouloir lancer la préparation de la commande\u00A0? Il est important que vous soyez proche de votre restaurant lors de cette action.',
        'clickandcollect.parking.closed': 'Oups\u00A0! Il est tard',
        'clickandcollect.parking.closed.message':
            'Nous n’avons pas la permission pour vous rencontrer sur le parking. Nous vous invitons à récupérer votre commande directement au comptoir, en restaurant.\nSouhaitez-vous lancer la préparation de la commande\u00A0?',
        'clickandcollect.orderstatus.onsite':
            'Déclenchez sa préparation dès que l’équipier vous indique une table.',
        'clickandcollect.orderstatus.takeaway':
            'Déclenchez la préparation dès que vous êtes à 5 MN du restaurant\u00A0!',
        'clickandcollect.orderstatus.drive':
            'Indiquez ce numéro à l’équipier lors de votre arrivée au drive.',
        'clickandcollect.confirmation.table.clue':
            'Ce restaurant propose le service à table. Lors de votre arrivée en restaurant, vous pouvez récupérer un chevalet et devez renseigner son numéro afin de déclencher la préparation de votre commande.',
        'ecommerce.continue.cart':
            'Votre panier contient déjà une commande {ecommerceMode} dans le restaurant {restaurant}. Êtes-vous sûr de vouloir la remplacer par une nouvelle commande\u00A0?',
        'ecommerce.continue.cart.title':
            'Une commande {ecommerceMode} est déjà en cours',
        'ecommerce.continue.cart.delivery': 'en livraison',
        'clickandcollect.continue.cart.ok': 'Poursuivre la commande en cours',
        'clickandcollect.continue.cart.new': 'Nouvelle commande',
        'clickandcollect.service.closed':
            'Ce restaurant ne propose actuellement pas le service de vente en ligne, veuillez réessayer ultérieurement.',
        'clickandcollect.restaurant.quota':
            'Ce restaurant présente actuellement un trop grand nombre de commandes. Nous vous invitons à retenter ultérieurement ou à changer de restaurant',
        'clickandcollect.discounts.coupons': 'Utilisez vos coupons Kingdom',
        'clickandcollect.discounts.kingdom.title':
            'Sélectionnez vos avantages kingdom',
        'clickandcollect.discounts.deals.title': 'Sélectionnez vos coupons',
        'clickandcollect.discounts.crowns': 'Convertissez vos couronnes',
        'clickandcollect.discounts.solde':
            "Votre solde actuel s'élève à\u00A0:",
        'clickandcollect.stepper.choice': 'Choix N°{index}',
        'clickandcollect.discounts.max.title': 'Maximum atteint',
        'clickandcollect.discounts.max':
            'Vous ne pouvez pas cumuler cette offre avec d’autres offres présentes dans votre panier.',
        'clickandcollect.discounts.selection.menu':
            'Choisissez le menu sur lequel vous souhaitez appliquer votre coupon\u00A0:',
        'clickandcollect.discounts.selection.product':
            'Choisissez le produit sur lequel vous souhaitez appliquer votre coupon\u00A0:',
        'clickandcollect.collect.tutorial.title': 'Votre commande est validée',
        'clickandcollect.collect.tutorial.drive':
            'Rendez-vous au drive et indiquez votre numéro de commande lors de votre passage.',
        'clickandcollect.collect.tutorial.servicetable':
            'En restaurant, renseignez votre numéro de chevalet et déclenchez la préparation de votre commande.',
        'clickandcollect.collect.tutorial.takeaway':
            "N'oubliez pas de déclencher votre commande quand vous êtes proche de votre restaurant.",
        'clickandcollect.collect.tutorial.parking':
            'Pensez à déclencher votre commande lorsque vous êtes à 5MN d’arriver sur le parking de votre restaurant.',
        'clickandcollect.collect.tutorial.parking.geoloc':
            'Vous pourrez déclencher la préparation de votre commande une fois à proximité de votre restaurant.',
        'ecommerce.collect.tutorial.delivery':
            'La prise en charge de votre commande est en cours, restez vigilant sur l’avancée de votre commande.',
        'ecommerce.collect.tutorial.tableorder':
            "Il n'y a plus qu'à patienter, votre commande arrive.",
        'clickandcollect.collect.cac.closed.title': 'Oups, il est trop tard',
        'clickandcollect.collect.cac.closed':
            'Il est trop tard pour déclencher votre commande depuis l’application, rendez-vous en restaurant pour l’activer. \n' +
            'Si vous ne le faites pas, votre commande sera automatiquement annulée',
        'clickandcollect.discounts.remove': 'Retirer la promotion',
        'clickandcollect.listorders.title': 'Mes commandes',
        'clickandcollect.listorders.past': 'Passées ({number})',
        'clickandcollect.listorders.current': 'En cours',
        'clickandcollect.listorders.detail': 'Voir le détail',
        'clickandcollect.listorders.total': 'Total\u00A0:\u00A0',
        'clickandcollect.listorders.empty': "Vous n'avez aucune commande",
        'clickandcollect.listorders.ordernumber': 'Commande\u00A0',
        'clickandcollect.discounts.unavailable':
            'Le coupon ne peut être utilisé. Aucun produit de ce coupon n’est disponible pour ce restaurant.',
        'clickandcollect.allergens.popup.title': 'Attention',
        'clickandcollect.allergens.popup':
            'Ce produit contient des allergènes sur lesquels vous avez mis une alerte. Souhaitez vous le commander\u00A0?',
        'clickandcollect.suggestions.title': 'Et autre chose\u00A0?',
        'clickandcollect.catalog.operation': 'En ce moment',
        'clickandcollect.game.coupon.icon.label': 'Offre spéciale',
        'clickandcollect.waiting.order.wait':
            'Veuillez patienter jusqu‘à la fin du chargement',
        'clickandcollect.waiting.order.validation':
            'Veuillez patienter, votre commande est en cours de validation par votre restaurant',
        'clickandcollect.waiting.order.fetchingProfile':
            'Récupération de votre compte kingdom en cours',
        'clickandcollect.waiting.order.payment.bank.validation':
            'Veuillez patienter, nous validons vos informations avec votre banque',
        'ecommerce.catalog.pick.up.later': 'Remis plus tard',
        'ecommerce.catalog.pick.up.now': 'Remis maintenant',
        'ecommerce.catalog.pick.up.modal.content':
            'Vous voulez récupérer le produit plus tard ?',
        'ecommerce.timeline.pending':
            'Votre commande est en cours de validation par votre restaurant.',
        'ecommerce.timeline.preparing':
            'Votre commande est en cours de préparation par le restaurant.',
        'ecommerce.timeline.isWaitingForDriver':
            "Votre commande est en attente d'assignation d'un livreur.",
        'ecommerce.timeline.isWaitingForDriverAfter5minutes':
            "Votre commande est en attente d'assignation d'un livreur. Cela peut prendre un peu plus de temps que prévu.",
        'ecommerce.timeline.isWaitingForDriverToPickOrder':
            'Votre commande est en attente de récupération par le livreur.',
        'ecommerce.timeline.clickandcollect.ready':
            'Votre commande est en attente de récupération.',
        'ecommerce.timeline.tableorder.ready':
            "Il n'y a plus qu'à patienter, votre commande arrive.",
        'ecommerce.timeline.error.no_merin_response':
            'Oups\u00A0! Une erreur est survenue. Veuillez vérifier le statut de votre commande directement en caisse.',
        'ecommerce.timeline.delivery.ready': 'Votre livreur est en chemin.',
        'ecommerce.timeline.delivery.almostDelivering':
            'Votre livreur est presque arrivé.',
        'ecommerce.timeline.delivered': 'Votre commande a bien été récupérée.',
        'ecommerce.timeline.delivered.tableorder':
            'Votre commande a bien été servie à table.',
        'ecommerce.timeline.delivery.driver.at.drop.off':
            'Votre livreur est arrivé, il vous attendra au point de retrait prévu.',
        'ecommerce.timeline.delivery.delivered':
            'Votre commande a bien été livrée.',
        'ecommerce.timeline.delivery.error':
            'Votre commande a été annulée. Veuillez ré-essayer ultérieurement.',
        'clickandcollect.timeline.advise.order.ready':
            'Restez vigilant, nous vous indiquerons dès que votre commande sera disponible à la récupération',
        'ecommerce.offer.error.threshold':
            'Le coupon sélectionné nécessite un montant minimum de commande de {value, plural, one {{value} euro} other {{value} euros}}',
        'ecommerce.unavailable.title':
            'Le service {ecommerceMode} est momentanément indisponible',
        'ecommerce.unavailable.description':
            'Oups ce service est momentanément indisponible, veuillez réessayer ultérieurement.',
        'ecommerce.delivery.key': 'En livraison',
        'ecommerce.kingtable.header': 'King Table',
        'ecommerce.kingtable.welcome.title': 'King Table',
        'ecommerce.kingtable.no-desktop.title':
            'Désolé, c’est juste sur mobile !',
        'ecommerce.kingtable.no-desktop.description':
            "Le King Table est uniquement disponible sur l'app ou le site mobile lors de votre visite en restaurant. Mais vous pouvez toujours commander en Click & Collect. On dit ça, on dit rien...",
        'ecommerce.kingtable.welcome.description':
            'Commandez et soyez servi à table.',
        'ecommerce.kingtable.welcome.description.imminentOpening.restaurant':
            'Le service à table n‘est pas encore ouvert.\nPlus que quelques minutes à attendre !',
        'ecommerce.kingtable.welcome.description.unavailable':
            'Oups, le service à table est actuellement fermé\u00A0!',
        'ecommerce.kingtable.welcome.description.closed.restaurant':
            'Le restaurant est actuellement fermé. Passez-donc nous voir demain\u00A0!',
        'ecommerce.kingtable.welcome.description.closed.outdoor':
            'Le service à table est actuellement indisponible en terrasse. Veuillez essayer en salle\u00A0!',
        'ecommerce.kingtable.welcome.description.closed.indoor':
            'Le service à table est actuellement indisponible en salle.',
        'ecommerce.kingtable.table': 'Table {number}',
        'ecommerce.kingtable.scan.description':
            'Scanner un QR code sur une table en restaurant',
        'geolocation.title': 'Votre géolocalisation doit être activée',
        'fine.geolocation.title':
            'Votre géolocalisation exacte doit être activée',
        'geolocation.required.message':
            'Afin d’assurer le service sélectionné de façon optimale, l’activation de votre géolocalisation est nécessaire.',
        'geolocation.background.required.title':
            'Souhaitez vous être alerté des bons plans autour de vous ?',
        'geolocation.background.required.message':
            'Pour être alerté des bons plans autour de vous, rendez vous dans vos paramètres et cliquez sur “Toujours autoriser”',
        'geolocation.background.required.messageAlt':
            "Pour être alerté des bons plans autour de vous, l'accès à votre position doit toujours être autorisé.",
        'geolocation.background.required.deny': 'Non, merci',
        'geolocation.background.required.accept': 'Accéder aux paramètres',
        'geolocation.background.required.acceptAlt': "Oui, d'accord",
        'fine.geolocation.required.message':
            'Afin d’assurer le service sélectionné de façon optimale, l’activation de votre géolocalisation exacte est nécessaire.',
        'fine.geolocation.collect.mode.required.message':
            'Afin d’assurer un service {collectMode} optimal, l’activation de votre géolocalisation exacte est nécessaire. Si vous ne souhaitez pas activer la géolocalisation exacte, rendez-vous directement dans le restaurant.',
        'geolocation.collect.mode.required.message':
            'Afin d’assurer un service {collectMode} optimal, l’activation de votre géolocalisation est nécessaire. Si vous ne souhaitez pas activer la géolocalisation, rendez-vous directement dans le restaurant.',
        'geolocation.collect.mode.required.message.retry':
            'Afin d’assurer un service {collectMode} optimal, l’activation de votre géolocalisation exacte est nécessaire. Si vous ne souhaitez pas activer la géolocalisation exacte, vous devrez sélectionner un autre mode de retrait.',
        'geolocation.phone.required.message':
            'La géolocalisation de votre téléphone est désactivée. Veuillez l’activer pour accéder au service demandé.',
        'geolocation.activate.label': 'Activer ma géolocalisation',
        'fine.geolocation.activate.label': 'Activer ma géolocalisation exacte',
        'geolocation.cancel.label': 'Maintenir ma géolocalisation désactivée',
        'geolocation.cancel.label.other.collect.mode':
            'Sélectionner un autre mode de retrait',
        'more.delivery.text': 'Se faire livrer',
        'more.beeper.text': 'Beeper mobile',
        'more.legal.information.text': 'Informations légales',
        'more.customers.information.text': 'Informations clients',
        'more.kingdom.authenticated.text': 'Salut, toi!',
        'burgerkare.title': 'Nos engagements Burger Kare',
        'burgerkare.people.title': 'Les équipes',
        'burgerkare.food.title': 'La qualité',
        'burgerkare.planet.title': 'La planète',
        'satisfaction.form.title': 'Enquête de satisfaction',
        'satisfaction.form.description':
            'Merci d’accepter de participer à cette courte enquête qui vise à améliorer l’expérience de nos clients dans nos restaurants.\n\nIl vous faudra moins d’une minute pour la compléter.',
        'satisfaction.form.restaurant.placeholder': 'Choisissez un restaurant',
        'satisfaction.form.restaurant':
            'Veuillez sélectionner le restaurant de votre dernière visite*',
        'satisfaction.form.global':
            'Comment évaluez-vous votre expérience globale lors de votre dernière visite chez Burger King\u00A0?',
        'satisfaction.form.grades':
            '(1 signifie que vous êtes très insatisfait, 5 que vous êtes très satisfait. Les notes intermédiaires vous permettent de nuancer votre jugement)',
        'satisfaction.form.order.type':
            'Lors de votre dernière visite, comment avez-vous réalisé votre commande\u00A0?',
        'satisfaction.form.order.type.classic': 'De manière traditionnelle',
        'satisfaction.form.order.type.cc':
            'Avec l’application ou le site Burger King (Click & Collect ou King Table)',
        'satisfaction.form.order.taking':
            'La prise de commande a été réalisée…',
        'satisfaction.form.order.taking.kiosk': 'En borne de commande',
        'satisfaction.form.order.taking.comptoir.drive':
            'Au comptoir, en drive',
        'satisfaction.form.order.taking.pickup.parking': 'Parking',
        'satisfaction.form.order.taking.web':
            'Sur le site internet Burger King',
        'satisfaction.form.order.taking.app': 'Sur l’application Burger King',
        'satisfaction.form.collect':
            'Quel mode de retrait avez-vous choisi\u00A0?',
        'satisfaction.form.collect.onsite': 'King table (sur place)',
        'satisfaction.form.questions.title':
            'Et qu’avez-vous pensé de votre expérience en restaurant\u00A0?',
        'satisfaction.form.grades.ambiance': 'Utilité du service',
        'satisfaction.form.grades.cleanliness': 'Propreté du restaurant',
        'satisfaction.form.grades.clarity':
            'Parcours de commande (facilité à trouver les produits voulus)',
        'satisfaction.form.grades.navigation': 'Accès au service de commande',
        'satisfaction.form.grades.waitingTime': "Temps d'attente",
        'satisfaction.form.grades.serviceQuality':
            'Qualité du service (amabilité du personnel, rapidité…)',
        'satisfaction.form.grades.orderAccuracy': 'Temps de commande',
        'satisfaction.form.grades.price': 'Paiement',
        'satisfaction.form.grades.seatAvailability':
            'Disponibilité des places assises',
        'satisfaction.form.age': 'Quel est votre âge\u00A0?*',
        'satisfaction.form.age.placeholder': 'Tapez ici votre âge',
        'satisfaction.form.age.invalid': "Merci d'indiquer un chiffre entier",
        'satisfaction.form.age.error':
            'Votre âge doit être compris entre 1 et 99 ans',
        'satisfaction.form.conditions':
            'Les informations que vous nous communiquerez resteront anonymes et strictement confidentielles et ne seront analysées que de manière globale avec l’ensemble des réponses des autres personnes qui nous ont déjà répondu.',
        'satisfaction.form.success':
            'Ce questionnaire est maintenant terminé.\nNous vous remercions pour le temps que vous y avez consacré et vous souhaitons une bonne fin de journée.',
        'future.whopper.title.prev':
            'Personne ne sait de quoi l’avenir sera fait.',
        'future.whopper.title':
            'envoyez-vous au moins\nquelque chose de bon dans le futur.',
        'future.whopper.title.post': '100 000 Whopper® offerts à s’envoyer.',
        'future.whopper.date': 'À quelle date envoyer votre Whopper\u00A0?*',
        'future.whopper.button.valid': 'Valider ma Date',
        'future.whopper.confirmation.title':
            'Votre whopper vient d’etre envoyé dans le futur.',
        'future.whopper.confirmation.date':
            'Rendez-vous le {date} pour le récupérer.',
        'future.whopper.confirmation.later':
            'Burger King vous souhaite un joyeux futur.',
        'future.whopper.unavailable.title': 'Oups, vous arrivez un peu tard.',
        'future.whopper.unavailable':
            'Tous nos Whopper sont déjà partis pour le futur.',
        'future.whopper.unavailable.later':
            'Rendez-vous dans un avenir proche pour en profiter à nouveau.',
        'future.whopper.date.error': "La date sélectionnée n'est pas valide.",
        'future.whopper.error':
            'Une participation a déjà été enregistrée avec ces informations. Veuillez vous référer aux conditions de participation de l’opération.',
        'future.whopper.agreements': "J'ai lu et j'accepte ",
        'future.whopper.legals':
            'Vous pouvez à tout moment utiliser le lien de désabonnement intégré dans nos emails.\n\nDans la limite des cent mille (100 000) premiers utilisateurs, un WHOPPER vous est offert sur présentation de ce coupon digital en restaurant. Ce coupon digital est utilisable le jour choisi lors de votre inscription, lequel a été reporté sur votre coupon. Il est valable dans tous les restaurants Burger King situés en France métropolitaine (en ce compris, la Corse), hors livraison. Il est nominatif et à usage unique. Il n’est ni remboursable, ni échangeable, ni cessible et non cumulable avec d’autres coupons ou offres promotionnelles en cours.',
        'future.whopper.legals.notice': '\nPour en savoir plus sur la ',
        'future.whopper.legals.notice.link': 'gestion de vos données\n',
        'see.legal.mentions': 'Informations et mentions légales',
        'deals.title': 'Mes coupons',
        'deals.none': 'Aucune offre disponible en ce moment',
        'deals.winning.form.title': 'Formulaire de récupération de gain',
        'deals.winning.form.subtitle':
            'Remplissez ce formulaire pour être recontacté et récupérer votre gain',
        'deals.winning.form.agreements':
            "J'ai plus de 16 ans et j’accepte que mes données personnelles recueillies dans le cadre du jeu soient traitées par Burger King France, responsable de traitement, et ses sous-traitants dans les conditions consultables ci-dessous.",
        'deals.winning.form.cgv':
            'En complétant ce formulaire j’accepte que mes données personnelles soient transmises aux prestataires partenaires dans le cadre de l’opération Whopper à gratter.',
        'deals.winning.form.legal.mentions.before':
            '\n\nLes données collectées sont indispensables à la participation au jeu «\u00A0Whopper à gratter\u00A0» et sont uniquement utilisées pour la récupération des gains physiques. Les données collectées sont conservées pendant une durée d’un an à compter de la clôture du jeu «\u00A0Whopper à gratter\u00A0». Comme données personnelles, sont collectées\u00A0: nom, prénom, téléphone, adresse, courriel.\n\nVous pouvez exercer vos droits à l’égard des données recueillies (notamment en matière d’accès, de copie, de rectification ou d’effacement, d’opposition, de portabilité) par courrier électronique en nous écrivant à Burger King France - Service Juridique – Données Personnelles – 34 Rue Mozart, 92110 Clichy ou ',
        'deals.winning.form.legal.mentions.after':
            '\n\nPour en savoir plus sur les données à caractère personnel collectées, la finalité de cette collecte, leur traitement, la durée de conservation des données et, plus généralement, sur la gestion de vos données, vous pouvez consulter notre politique de protection des données disponible sur ',
        'deals.winning.form.not.available':
            'Ce formulaire est indisponible. Si vous avez déjà complété ce formulaire, vous allez recevoir un e-mail de confirmation.',
        'deals.winning.form.success':
            'Votre formulaire a bien été envoyé, vous allez recevoir un e-mail de confirmation.',
        'veggie.king.title.prev': 'Notre tout premier burger végétal',
        'veggie.king.title': 'Récupérez votre veggie king offert\u00A0!',
        'veggie.king.title.post.before': 'Et venez le tester dès\u00A0',
        'veggie.king.title.post.after': 'dans tous nos restaurants',
        'veggie.king.confirmation.title':
            'Votre coupon veggie king offert vient d’être envoyé par e-mail\u00A0!',
        'veggie.king.confirmation.date.before': 'Rendez-vous dès\u00A0',
        'veggie.king.confirmation.date.after':
            'pour le déguster dans le restaurant de votre choix\n',
        'veggie.king.confirmation.tasting':
            'Nous vous souhaitons une excellente dégustation\u00A0!',
        'veggie.king.unavailable.text':
            'Vous avez déjà profité de l’offre ou tous les coupons Veggie King ont malheureusement déjà été distribués.',
        'veggie.king.unavailable.news':
            'Mais bonne nouvelle\u00A0! Vous pouvez toujours venir le déguster à partir du {startDate} dans tous nos restaurants',
        'veggie.king.error':
            'Une participation a déjà été enregistrée avec ces informations. Veuillez vous référer aux conditions de participation de l’opération.',
        'veggie.king.legals':
            '\nVous pouvez à tout moment utiliser le lien de désabonnement intégré dans nos emails.\n\nDans la limite des cinquante mille (50 000) premiers utilisateurs, un Veggie King vous est offert sur présentation du coupon digital en restaurant. Ce coupon digital est valable à partir du {startDate} jusqu’au {endDate} inclus. Il est utilisable dans tous les restaurants Burger King situés en France métropolitaine (dont la Corse), hors livraison. Il est à usage unique. Il n’est pas remboursable, ni échangeable, ni cessible, ni cumulable avec d’autres coupons ou offres promotionnelles en cours. 1 coupon digital par téléphone et par e-mail.\n\n',
        'veggie.king.legals.notice': 'Pour en savoir plus sur la ',
        'veggie.king.legals.notice.link': 'gestion de vos données\n',
        'veggie.king.legals.email':
            '* L’adresse e-mail est nécessaire pour s’inscrire.\n\n',
        'veggie.king.legals.cajun.sauce':
            'Sauce cajun : sauce épicée façon cajun. King = Roi. Veggie = Végétarien. Ce produit est fabriqué sur les mêmes chaînes de préparation que l’ensemble des produits de la gamme. Le haché végétal est cuit dans le même grill que les steaks hachés. Présence d’œufs dans la sauce cajun. Haché végétal produit et distribué par «\u00A0LE BOUCHER VEGETARIEN.\u00A0»',
        'yes.i.do': 'Oui, je le veux',
        'yes.sure': 'Oui, je suis sûr',
        'no.later': 'Non, plus tard',
        'qr.code.scanner.unauthorized.camera':
            "L'accès à votre caméra est nécessaire pour activer le scan.",
        'qr.code.scanner.howto.chrome':
            'Sélectionner Réglages > Chrome > Activer l’appareil photo',
        'qr.code.scanner.howto.safari':
            'Appuyer sur la barre d’adresse > Réglages du site web > Appareil Photo > Autoriser',
        'qr.code.scanner.instruction':
            "Aligner le QR Code à l'intérieur du cadre",
        'qr.code.table.error':
            'Ce QR Code est illisible ou ne correspond pas à une table BK.',
        'tupreferesking.home.entercode':
            'Saisissez votre code Tu Préfères King pour jouer !',
        'tupreferesking.home.enterOrScanCode':
            'Saisissez ou scannez votre code Tu Préfères King pour jouer !',
        'tupreferesking.home.code.placeholder':
            'Entrer le code type BKCL3F3UUU',
        'tupreferesking.home.code.error.invalid':
            'Ce code est invalide. Merci de réessayer avec un autre code',
        'tupreferesking.home.done.1': 'Tu Préfères King, c’est fini !',
        'tupreferesking.home.done.2':
            'Notre jeu 100% gagnant Tu Préfères King est maintenant terminé, merci d’avoir joué !',
        'tupreferesking.home.code-input-heading':
            '1 menu enfant acheté = 1\u00A0cadeau ENFANT ou PARENT',
        'tupreferesking.home.promotionCaption1': `L'ÉTÉ SERA CHOIX !   `,
        'tupreferesking.home.promotionCaption2': `Le soleil brille, les oiseaux chantent et votre petite famille est sur le point d'être chamboulée.\n Oui, les dilemmes de « Tu Préfères King » sont de retour. Parmi les 2,5 millions de cadeaux à gagner, lesquels seront pour vous et lesquels seront pour vos enfants ?`,
        'tupreferesking.home.promotionCaption3': 'Allez, bonne chance !',
        'tupreferesking.duel.title': "C'EST LE MOMENT !",
        'tupreferesking.duel.sub-title': 'Choisissez votre gain :',
        'tupreferesking.duel.keep-card.title': "N'oubliez pas votre carte",
        'tupreferesking.duel.keep-card.description':
            'Conservez bien votre carte de jeu, elle pourrait vous être demandée afin de confirmer votre gain. Pas folle la guêpe.',
        'tupreferesking.duel.carefull.title': ' *',
        'tupreferesking.duel.carefull.bouee':
            '* Bouée adulte. Interdit aux enfants de moins de 14 ans. Ne protège pas de la noyade. Réservée aux nageurs. Lire les instructions avant utilisation.',
        'tupreferesking.duel.carefull.bracelet':
            '* Attention, ceci n’est pas un jouet. Bracelet adapté aux plus de 3 ans.',
        'tupreferesking.duel.carefull.casquette':
            '* Casquette enfant adaptée aux plus de 4 ans.',
        'tupreferesking.duel.carefull.frisbee':
            '* Pour la pratique du sport dès l’âge de 7 ans.',
        'tupreferesking.duel.carefull.voiture':
            '* Réservé ux enfants entre 3 et 8 ans.',
        'tupreferesking.duel.carefull.bodyboard':
            "* Conçu pour les enfants de 4 à 8 ans (15 à 25Kg). Sans palmes. Eau jusqu'au nombril. Top ou shorty obligatoire.",
        'tupreferesking.duel.gift': 'Un cadeau pour',
        'tupreferesking.duel.CHILD': 'les enfants',
        'tupreferesking.duel.PARENT': 'les adultes',
        'tupreferesking.duel.confirm.cta': 'Confirmer mon cadeau',
        'tupreferesking.duel.confirm.modal.title':
            'C’est votre dernier mot\u00A0?',
        'tupreferesking.duel.confirm.modal.body':
            'Vous avez encore la possibilité de changer de cadeau. Après on dit ça, on dit rien...',
        'tupreferesking.win.layout.title': 'VOTRE GAIN',
        'tupreferesking.win.layout.sub-title': 'Merci d‘avoir joué !',
        'tupreferesking.win.description':
            'Très bon choix ! Appuyer sur le bouton pour confirmer votre gain',
        'tupreferesking.win.description.logged':
            'Connectez-vous ou inscrivez-vous au Kingdom pour récupérer votre cadeau',
        'tupreferesking.win.get-gift': 'Récupérer mon cadeau',
        'tupreferesking.win.signin-get-gift':
            "M'identifier pour récupérer mon gain",
        'tupreferesking.email.validate': 'Confirmer votre e-mail',
        'tupreferesking.email.title': 'Continuer avec un e-mail',
        'tupreferesking.email.description':
            'Votre gain vous sera envoyé sur votre adresse e-mail. Choisissez bien !',
        'tupreferesking.email.placeholder': 'Saisissez votre e-mail',
        'tupreferesking.email.optin':
            "Je souhaite recevoir par e-mail l'actualité, les nouveautés et les offres Burger King® France.",
        'tupreferesking.email.readRules':
            'Je confirme avoir lu et accepté les conditions de participation au jeu <aRules>(Règlement de Jeu)</aRules> et politique de protection des données personnelles.*',
        'tupreferesking.email.oldEnough': 'Je confirme avoir plus de 15 ans *',
        'tupreferesking.legal':
            'Votre adresse électronique est enregistrée dans un fichier informatisé et sauvegardé par la société Burger King France, domiciliée 34 Rue Mozart à Clichy (92110), en qualité de responsable de traitement, aux fins de gestion du jeu (prise en compte de la participation et remise de la dotation) et le cas échéant, de vous envoyer des communications du réseau Burger King®. La base légale du traitement est le consentement.{br}' +
            'L’adresse électronique doit obligatoirement être fournie. Dans le cas contraire, votre participation au jeu ne pourra pas être prise en compte.{br}' +
            'Les destinataires seront uniquement les salariés de la société Burger King France ou de ses filiales, ainsi que les prestataires techniques intervenant dans la gestion du jeu et, si vous avez accepté de recevoir du réseau Burger King®, ceux qui sont précisés à l’article 12 de notre politique de protection des données.{br}' +
            'L’adresse électronique est conservée pendant la durée nécessaire à la gestion du jeu et, si vous avez accepté de recevoir des communications du réseau Burger King®, jusqu’à désinscription au travers de votre compte Kingdom, ou par l’utilisation des liens de désabonnement prévus à cet effet dans nos envois.{br}' +
            'Vous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre droit à la limitation du traitement de vos données ainsi que votre droit à la portabilité de vos données.{br}' +
            'Pour exercer ces droits ou pour toute question sur le traitement de vos données, vous pouvez contacter notre délégué à la protection des données à l’adresse électronique suivante : <email>dpo@burgerking.fr</email>. Si vous estimez, après nous avoir contactés, que vos droits « Informatique et Libertés » ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL.',
        'tupreferesking.mandatory': '* Mentions Obligatoires',
        'tupreferesking.win.modal.done.title': 'C’est envoyé !',
        'tupreferesking.win.modal.done.text.immediate':
            'Votre gain a bien été validé. Un email contenant votre gain a été envoyé à l’adresse email <email>{email}</email>',
        'tupreferesking.win.modal.done.text.later':
            'Votre gain a bien été validé. Un email de confirmation a été envoyé à l’adresse email <email>{email}</email>',
        'tupreferesking.win.modal.done.cta': 'Ok, j’ai compris',
        'tupreferesking.errors.INVALID_CODE':
            'Ce code est invalide. Merci de réessayer avec un autre code',
        'tupreferesking.errors.INVALID_CAPTCHA':
            'Une erreur est survenue. Êtes-vous un robot ?',
        'tupreferesking.errors.INTERNAL_ERROR':
            'Oups, nous avons un problème. Merci de réessayer dans quelques instants',
        'tupreferesking.errors.INVALID_TPK_TOKEN':
            'Ce code est invalide. Merci de réessayer avec un autre code',
        'tupreferesking.errors.MISSING_EMAIL':
            'Merci de renseigner votre adresse email',
        'tupreferesking.errors.BAD_CHOICE':
            'Merci de choisir entre le cadeau parent ou enfant',
        'tupreferesking.errors.WRONG_STEP':
            "Cette étape n'est pas possible à ce stade",
        'tupreferesking.errors.ALREADY_COLLECTED':
            'Ce code a déjà été utilisé. Merci de réessayer avec un autre code',
        'tupreferesking.errors.BAD_QRCODE':
            "Ce QRCode n'est pas un qrcode Tu Préfères King",
        'tupreferesking.home.explanation.title':
            'COMMENT RÉCUPÉRER SON CADEAU FOOD OU GOODIES ?',
        'tupreferesking.home.explanation.desktop.title':
            'COMMENT RÉCUPÉRER MON CADEAU ?',
        'tupreferesking.home.explanation.description':
            'Vous avez gagné un lot qui se mange ou un goodies ? On vous explique tout !',
        'tupreferesking.home.explanation.borne.title': 'Borne',
        'tupreferesking.home.explanation.text.1':
            "Récupérez votre coupon envoyé par e-mail ou affiché sur l'écran final du parcours de jeu.",
        'tupreferesking.home.explanation.borne.text.2':
            'Rendez-vous sur la catégorie « un coupon, une promo » ou la vignette « Tu préfères King ».',
        'tupreferesking.home.explanation.borne.text.3':
            'Scannez le QR Code ou entrez le code à 7 caractères figurant sur le coupon digital.',
        'tupreferesking.home.explanation.text.4': `Le cadeau s'ajoute à votre panier sans minimum d'achat.`,
        'tupreferesking.home.explanation.text.5':
            'Récupérez votre cadeau avant le 12 août.',
        'tupreferesking.home.explanation.drive.title': 'Drive',
        'tupreferesking.home.explanation.drive.text.2':
            'Rendez-vous sur la piste drive',
        'tupreferesking.home.explanation.drive.text.3':
            'Scannez votre QR Code sur la borne drive ou communiquez votre code à 7 caractères figurant sur votre coupon digital lors de la passation de commande.',
        'tupreferesking.home.explanation.cc.title': 'Click & Collect',
        'tupreferesking.home.explanation.cc.text.2':
            'Sélectionnez un restaurant et un mode de retrait.',
        'tupreferesking.home.explanation.cc.text.3':
            'Rendez-vous dans la catégorie « un coupon, une promo ».',
        'tupreferesking.home.explanation.cc.text.4':
            'Entrez le code à 7 caractères figurant sur votre coupon digital.',
        'tupreferesking.home.explanation.kingtable.title': 'King Table',
        'tupreferesking.home.explanation.kingtable.text.2':
            'Scannez le QR Code sur votre table.',
        'tupreferesking.home.explanation.kingtable.text.3':
            'Rendez-vous sur la catégorie « un coupon, une promo ».',
        'tupreferesking.home.explanation.kingtable.text.4':
            'Entrez le code à 7 caractères figurant sur votre coupon digital.',
        'tupreferesking.home.code-input.heading':
            'Enfants ou parents, mais qui aura le cadeau',
        'tupreferesking.home.explanations.1.title': 'COMMENT ON JOUE ?',
        'tupreferesking.home.explanations.1.text.1':
            'Commandez un menu enfant : King Junior ou King Jr+',
        'tupreferesking.home.explanations.1.text.2':
            'Décollez la carte de jeu du sac du menu enfant',
        'tupreferesking.home.explanations.1.text.3':
            'Scannez le QR Code avec votre téléphone ou tapez le code à 10 caractères présents sur la carte de jeu',
        'tupreferesking.home.explanations.1.text.4':
            'Découvrez votre duel de cadeaux',
        'tupreferesking.home.explanations.1.text.5': 'Lancez les négociations',
        'tupreferesking.home.explanations.big.win.title':
            'VOUS AVEZ GAGNÉ LE GROS LOT ?',
        'tupreferesking.home.explanations.big.win.text.1':
            'Connectez-vous à votre compte Kingdom ou créez-en un',
        'tupreferesking.home.explanations.big.win.text.1.bis':
            'Félicitez vous.',
        'tupreferesking.home.explanations.big.win.text.2': `Regardez vos e-mails et remplissez le formulaire (sauf si vous avez remporté 2 places pour un match de foot, activez votre gain directement sur Tick'nBox)`,
        'tupreferesking.home.explanations.big.win.text.3':
            'Recevez un e-mail avec la confirmation de votre gain',
        'tupreferesking.home.explanations.big.win.text.4': `Recevez votre cadeau à votre domicile à partir de septembre, petit veinard (s'il s'agit d'une voiture Suzuki Vitara, vous serez contacté par téléphone).`,
        'tupreferesking.home.legals.title': '* Mentions obligatoires',
        'tupreferesking.home.legals.cta': 'Voir le règlement de l’opération',
        'tupreferesking.home.faq.title': 'Comment ça marche ?',
        'tupreferesking.home.faq.1.q':
            'Comment obtenir des cartes de jeu\u00A0?',
        'tupreferesking.home.faq.1.a':
            'C’est simple. Pour obtenir une carte de jeu Tu préfères King, vous devez acheter un menu enfant (King Junior ou King Jr+) entre le 9 juillet et le 5 août 2024. Pour chaque carte de jeu c’est un cadeau au choix pour les enfants ou pour les parents. Pensez à bien conserver votre carte de jeu, elle pourrait vous être réclamée pour obtenir votre cadeau.',
        'tupreferesking.home.faq.2.q': 'Comment récupérer mes cadeaux\u00A0?',
        'tupreferesking.home.faq.2.a1':
            'Vous serez redirigés vers un formulaire, si vous avez gagné\u00A0:',
        'tupreferesking.home.faq.2.a2':
            'Voiture enfant\n' +
            'Voiture Suzuki Vitara\n' +
            'Console de jeux\n' +
            'Télévision Hisense\n' +
            'Talkie-Walkie VTech\n' +
            'Smartphone pliant Motorola Razr50\n' +
            'Dinette\n' +
            'Réfrigérateur Hisense\n' +
            'Montre enfant VTech\n' +
            'Montre adulte\n' +
            'Karaoké VTech\n' +
            'Enceinte Hisense\n' +
            'Baby-Foot\n' +
            'Planche de bodyboard enfant\n' +
            'Planche à découper\n' +
            'Qui est-ce ?\n' +
            'Boule Quies®',
        'tupreferesking.home.faq.2.a3':
            'Ce formulaire devra être dûment complété en ligne en se connectant à votre compte Kingdom (ou en créant un compte Kingdom). Une fois complété, un e-mail de confirmation vous sera envoyé. Ensuite, le cadeau vous sera envoyé à votre domicile après vérification de la conformité de votre participation, à partir de septembre 2024.',
        'tupreferesking.home.reminder-keep':
            'Pour rappel : il est important de conserver votre carte de jeu, elle pourrait vous être réclamée pour obtenir votre cadeau.',
        'tupreferesking.home.2.a3.car':
            "S'agissant de la voiture Suzuki Vitara, la remise en concession se fera dans un délai qui vous sera communiqué lors d'une prise de contact et dépendra du délai de fabrication du concessionnaire.",
        'tupreferesking.home.faq.2.a5':
            'Si vous avez gagné 2 places pour un match de foot :',
        'tupreferesking.home.faq.2.a6':
            "Vous devrez vous connecter à votre compte Kindgom (ou le créer le cas échéant) afin de recevoir l'e-mail avec le code d'activation à utiliser sur le site du partenaire (",
        'tupreferesking.home.faq.2.a7':
            'https://www.ticknbox.com/fr_FR/100-foot-matchs-stadiumtour.html',
        'tupreferesking.home.faq.2.a8':
            ') : Le coffret 2 places de match de foot est valable 12 mois à partir du 9 juillet 2024.',
        'tupreferesking.home.faq.2.a9': 'Et si vous gagné :',
        'tupreferesking.home.faq.2.a10':
            'Bouée Whopper®\n' +
            'Frisbee Burger King\n' +
            'Casquette enfant Burger King\n' +
            'Bracelet enfant Burger King\n' +
            'Gourde Oasis®\n' +
            'Des lots « food »',
        'tupreferesking.home.faq.2.a11':
            'Vous recevrez au sein du parcours de jeu un e-mail et un coupon digital à utiliser chez Burger King sur les bornes, en Click and Collect, King Table, Drive ou en comptoir.',
        'tupreferesking.home.faq.2.a12':
            "Ces coupons sont à utiliser jusqu'au 12 août 2024 inclus.",
        'tupreferesking.home.faq.3.q': 'Comment utiliser ces coupons\u00A0?',
        'tupreferesking.home.faq.3.a1': 'En borne :',
        'tupreferesking.home.faq.3.a1.text':
            "je scanne mon QR CODE ou saisis mon code à 7 caractères figurant sur mon coupon digital dans l'espace « un coupon / une promotion » ou vignette “Tu Préfères King”.",
        'tupreferesking.home.faq.3.a2': 'En drive :',
        'tupreferesking.home.faq.3.a2.text':
            'je scanne mon QR CODE sur la borne Drive (pour les restaurants Burger King® en disposant) ou je communique mon code à 7 caractères figurant sur mon coupon digital lors de la passation de commande.',
        'tupreferesking.home.faq.3.a3': 'En Click & Collect :',
        'tupreferesking.home.faq.3.a3.text':
            'après avoir sélectionné un restaurant et son mode de retrait, je me rends sur la catégorie « un coupon / une promotion » et je saisis mon code à 7 caractères figurant sur mon coupon digital.',
        'tupreferesking.home.faq.3.a4': 'En King Table :',
        'tupreferesking.home.faq.3.a4.text':
            'après avoir scanné le QR CODE sur votre table en restaurant, je me rends sur la catégorie « un coupon / une promotion » et je saisis mon code à 7 caractères figurant sur mon coupon digital.',
        'tupreferesking.home.faq.3.a5': 'Au comptoir :',
        'tupreferesking.home.faq.3.a5.text':
            'je présente mon QR CODE ou je communique mon code à 7 caractères figurant sur mon coupon digital. Cependant, pour gagner du temps, nous vous recommandons d’activer le QR CODE sur la borne.',
        'tupreferesking.home.faq.4.q':
            'Quels sont les goodies et les gros lots ?',
        'tupreferesking.home.faq.4.a1': 'Goodies :',
        'tupreferesking.home.faq.4.a2':
            'Bouée Whopper®\n' +
            'Frisbee Burger King\n' +
            'Casquette enfant Burger King\n' +
            'Bracelet enfant Burger King\n' +
            'Gourde Oasis®\n' +
            'Des lots « food »',
        'tupreferesking.home.faq.4.a3': 'Gros lots :',
        'tupreferesking.home.faq.4.a4':
            'Voiture enfant\n' +
            'Voiture Suzuki Vitara\n' +
            'Console de jeux\n' +
            'Télévision Hisense\n' +
            'Talkie-Walkie VTech\n' +
            'Smartphone pliant Motorola Razr50\n' +
            'Dinette\n' +
            'Réfrigérateur Hisense\n' +
            'Montre enfant VTech\n' +
            'Montre adulte\n' +
            'Karaoké VTech\n' +
            'Enceinte Hisense\n' +
            'Baby-Foot\n' +
            'Planche de bodyboard enfant\n' +
            'Planche à découper\n' +
            'Qui est-ce ?\n' +
            'Boule Quies®\n' +
            '2 places pour un match de Foot',
        'tupreferesking.goodies.mainTitle': 'OÙ SONT LES CADEAUX ?',
        'tupreferesking.goodies.explainBlockTitle':
            'Trouver votre gain dans le restaurant le plus proche de chez vous :',
        'tupreferesking.goodies.selectGainCaption':
            'Sélectionner un type de gain',
        'tupreferesking.goodies.selectRestaurantCaption':
            'Sélectionner un restaurant',
        'tupreferesking.goodies.availabilityError':
            'Une erreur a eu lieu lors de la recherche de disponibilité du gain dans le restaurant. Veuillez rafraîchir la page ou faire une nouvelle recherche avec un autre restaurant à proximité.',
        'tupreferesking.goodies.selectGainAndRestaurantCaption':
            'Sélectionner un type de gain et un restaurant',
        'tupreferesking.goodies.gainAlmostSoldOut':
            'Ce type de gain est bientôt épuisé à ',
        'tupreferesking.goodies.gainStockRatherLow':
            'Attention, pour ce type de gain, le stock est plutot faible à ',
        'tupreferesking.goodies.gainAvailable':
            'Bonne nouvelle, votre gain est bien disponible à ',
        'tupreferesking.goodies.gainSoldOutCaption':
            'Cherchez un autre restaurant pour trouver votre gain. Sinon rendez-vous dans ce restaurant, un produit équivalent vous attend.',
        'tupreferesking.goodies.getGainCaption':
            'Récupérez votre gain dans ce restaurant en activant le coupon digital en borne, drive, click and collect ou au comptoir.',
        'tupreferesking.home.legals.see-rules':
            'Voir le règlement de l’opération',
        'tupreferesking.qrcode.title': 'VOTRE GAIN',
        'tupreferesking.qrcode.subtitle': "Merci d'avoir joué !",
        'tupreferesking.qrcode.expirationDate': `Jusqu'au {date}`,
        'tupreferesking.qrcode.share': 'Partager',
        'tupreferesking.qrcode.download': 'Télécharger',
        'tupreferesking.qrcode.explanations.title':
            'Comment récupérer mon gain ?',
        'tupreferesking.qrcode.explanations.description': `Saisissez votre code ou scannez votre QR Code en borne, au drive ou sur l'app / site web Burger King pour récupérer votre gain.`,
        'tupreferesking.qrcode.disponibility':
            'Vérifier la dispo en restaurant',
        'tupreferesking.qrcode.mandatory': 'Infos & mentions légales',
        'tupreferesking.qrcode.pdf.name': 'TuPreferesKingQrCode.pdf',
        'tupreferesking.qrcode.mail.subject':
            'Burger King - Qr Code - Tu Preferes King',
        'tupreferesking.qrcode.mail.body.title': 'Bonjour,',
        'tupreferesking.qrcode.mail.body':
            'Ceci est un lien vers le Qr Code Tu preferes King gagné :',
        yes: 'Oui',
        no: 'Non',
        ok: 'Ok',
        cancel: 'Annuler',
        error: 'Erreur',
        oops: 'Oups',
        close: 'Fermer',
        delete: 'Supprimer',
        retry: 'Réessayer',
        continue: 'Continuer',
        confirm: 'Confirmer',
        version: 'Version\u00A0{version}',
        deviceId: 'Device ID\u00A0: ',
        airshipId: 'Airship ID\u00A0: ',
        firebaseId: 'Firebase ID\u00A0: ',
        apiVersion: 'Api version\u00A0: ',
        apiUrl: 'API URL\u00A0: ',
        deliveryApiURL: 'Delivery API URL\u00A0: ',
        storageApiURL: 'Storage URL',
        goback: 'Retour',
        'splash.fidelity': 'La fidélité',
        'splash.advantages': 'a ses avantages',
        'adyen.form.new.card.name.placeholder': 'Nom sur la carte',
        'adyen.form.new.card.number.placeholder': 'Numéro de carte',
        'adyen.form.new.card.expiration.placeholder': 'Expiration',
        'adyen.form.new.card.cvc.placeholder': 'CVC',
        'kingscratch.bravo': 'Bravo\u00A0!',
        'kingscratch.lose': 'Oups...',
        'kingscratch.see-coupon': 'Voir mon gain',
        'kingscratch.go-back': 'Revenir à l’accueil',
        'kingscratch.modal.title': 'Êtes-vous sûr de votre choix\u00a0?',
        'kingscratch.modal.content':
            "Votre sélection est définitive. Vous n'aurez plus qu'à gratter",
        'kingscratch.modal-points.title': 'Êtes-vous sûr de votre choix\u00a0?',
        'kingscratch.modal-points.content':
            '{kingdomPointsForRetry, plural, =0 {Votre sélection est définitive, vous serez débité de {kingdomPointsForRetry} couronne. Après ça, vous n’aurez plus qu’à gratter.} one {Votre sélection est définitive, vous serez débité de {kingdomPointsForRetry} couronne. Après ça, vous n’aurez plus qu’à gratter.} other {Votre sélection est définitive, vous serez débité de {kingdomPointsForRetry} couronnes. Après ça, vous n’aurez plus qu’à gratter.}}',
        'kingscratch.modal-points.button': 'Oui - {kingdomPointsForRetry}',
        'kingscratch.modal-points.not-enough.content':
            'Oups, vous n’avez pas assez de couronnes pour pouvoir gratter une case à nouveau',
        'kingscratch.modal-points.not-enough.button': 'Pas assez de couronnes',
        'kingscratch.leave-modal.title': 'Vous partez déjà\u00a0?',
        'kingscratch.leave-modal.content':
            "Il vous reste un gain à gratter. Reprenez votre grattage à tout moment depuis l’onglet King Gratt' de votre Kingdom.",
        'kingscratch.scratch.help': 'Qu’attendez-vous pour gratter ?'
    }
}
export { fr }
